export const JOBS_CONSTANTS = {
  "payload": {
    "trace": {
      "traceId": "53fe392d-d17d-423f-b46f-2543b3f80cbe"
    },
    "status": {
      "success": true
    },
    "payload": [
      {
        "idOcupacion": 251,
        "descripcion": "Comerciante de alcohol (excepto centros nocturnos)"
      },
      {
        "idOcupacion": 1007,
        "descripcion": "Cesante"
      },
      {
        "idOcupacion": 187,
        "descripcion": "Capataz de obreros ferroviarios"
      },
      {
        "idOcupacion": 154,
        "descripcion": "Buceo militar"
      },
      {
        "idOcupacion": 1091,
        "descripcion": "Militar -Artificiero de explosivos"
      },
      {
        "idOcupacion": 7,
        "descripcion": "Acupuntor / Acupunturista"
      },
      {
        "idOcupacion": 947,
        "descripcion": "Traductor a lenguaje de los signos"
      },
      {
        "idOcupacion": 115,
        "descripcion": "Aviador militar - aviones de combate y observacion"
      },
      {
        "idOcupacion": 512,
        "descripcion": "Gerente - tareas administrativas"
      },
      {
        "idOcupacion": 1073,
        "descripcion": "Jubilado"
      },
      {
        "idOcupacion": 930,
        "descripcion": "Tecnico de maquinaria"
      },
      {
        "idOcupacion": 843,
        "descripcion": "Productor/fabricante insecticidas"
      },
      {
        "idOcupacion": 286,
        "descripcion": "Cosechador"
      },
      {
        "idOcupacion": 361,
        "descripcion": "Egiptologo"
      },
      {
        "idOcupacion": 380,
        "descripcion": "Empleado de bar o pub (excepto centros nocturnos)"
      },
      {
        "idOcupacion": 678,
        "descripcion": "Manipulador de acido alcali"
      },
      {
        "idOcupacion": 526,
        "descripcion": "Guardaespaldas - Custodia"
      },
      {
        "idOcupacion": 117,
        "descripcion": "Aviador militar - exhibiciones acrobaticas"
      },
      {
        "idOcupacion": 401,
        "descripcion": "Encuestador - trabajo en oficina"
      },
      {
        "idOcupacion": 756,
        "descripcion": "Operario"
      },
      {
        "idOcupacion": 554,
        "descripcion": "Industria maderera"
      },
      {
        "idOcupacion": 47,
        "descripcion": "Animador - Entretenimiento"
      },
      {
        "idOcupacion": 184,
        "descripcion": "Capataz - Tareas en superficies"
      },
      {
        "idOcupacion": 403,
        "descripcion": "Enfermera (sin exposicion a sustancias radioactivas)"
      },
      {
        "idOcupacion": 888,
        "descripcion": "Registrador de Propiedad"
      },
      {
        "idOcupacion": 304,
        "descripcion": "Demoledor sin uso de explosivos"
      },
      {
        "idOcupacion": 590,
        "descripcion": "Ingeniero de procesos"
      },
      {
        "idOcupacion": 156,
        "descripcion": "Buceo profesional - cuevas y grutas"
      },
      {
        "idOcupacion": 978,
        "descripcion": "Zapatero"
      },
      {
        "idOcupacion": 122,
        "descripcion": "Aviador militar - tropas de paracaidismo"
      },
      {
        "idOcupacion": 273,
        "descripcion": "Controlador aereo"
      },
      {
        "idOcupacion": 513,
        "descripcion": "Geriatra"
      },
      {
        "idOcupacion": 333,
        "descripcion": "Director - Escena"
      },
      {
        "idOcupacion": 145,
        "descripcion": "Botanico"
      },
      {
        "idOcupacion": 1041,
        "descripcion": "Ingeniero de procesos - Administrativo"
      },
      {
        "idOcupacion": 195,
        "descripcion": "Carpintero"
      },
      {
        "idOcupacion": 501,
        "descripcion": "Gasista instalador"
      },
      {
        "idOcupacion": 1021,
        "descripcion": "Dealer en Casino"
      },
      {
        "idOcupacion": 359,
        "descripcion": "Editor"
      },
      {
        "idOcupacion": 983,
        "descripcion": "Agricultor - Administrativo"
      },
      {
        "idOcupacion": 912,
        "descripcion": "Sismologo"
      },
      {
        "idOcupacion": 668,
        "descripcion": "Linotipista"
      },
      {
        "idOcupacion": 1029,
        "descripcion": "Fisico - Quimico - Bioquimico - Administrativo"
      },
      {
        "idOcupacion": 835,
        "descripcion": "Politologo"
      },
      {
        "idOcupacion": 1069,
        "descripcion": "Investigador privado - sin armas - Administrativo"
      },
      {
        "idOcupacion": 583,
        "descripcion": "Ingeniero de la marina"
      },
      {
        "idOcupacion": 395,
        "descripcion": "Empleado industria manufacturera"
      },
      {
        "idOcupacion": 896,
        "descripcion": "Representante"
      },
      {
        "idOcupacion": 977,
        "descripcion": "Viticultor"
      },
      {
        "idOcupacion": 256,
        "descripcion": "Concejal - Paises democraticos"
      },
      {
        "idOcupacion": 130,
        "descripcion": "Barrendero"
      },
      {
        "idOcupacion": 1068,
        "descripcion": "Ingeniero Sanitario - Campo"
      },
      {
        "idOcupacion": 386,
        "descripcion": "Empleado de hotel, hostal u hoteleria servicios domesticos"
      },
      {
        "idOcupacion": 573,
        "descripcion": "Ingeniero construccion de barcos/embarcaciones"
      },
      {
        "idOcupacion": 891,
        "descripcion": "Reparador pozos septicos"
      },
      {
        "idOcupacion": 369,
        "descripcion": "Empleada tareas domesticas"
      },
      {
        "idOcupacion": 555,
        "descripcion": "Industria manufacturera"
      },
      {
        "idOcupacion": 533,
        "descripcion": "Helmintologo"
      },
      {
        "idOcupacion": 79,
        "descripcion": "Aserrador - Industrial"
      },
      {
        "idOcupacion": 876,
        "descripcion": "Quimico industrial"
      },
      {
        "idOcupacion": 172,
        "descripcion": "Camarero de tren"
      },
      {
        "idOcupacion": 921,
        "descripcion": "Taladrador"
      },
      {
        "idOcupacion": 379,
        "descripcion": "Empleado compañia de seguros"
      },
      {
        "idOcupacion": 939,
        "descripcion": "Topografo"
      },
      {
        "idOcupacion": 440,
        "descripcion": "Fabricante de calzado"
      },
      {
        "idOcupacion": 1038,
        "descripcion": "Gestor de ventas"
      },
      {
        "idOcupacion": 954,
        "descripcion": "Transporte de personas (taxis/autobuses/autocares/ambulancias)"
      },
      {
        "idOcupacion": 1063,
        "descripcion": "Ingeniero Metalurgico"
      },
      {
        "idOcupacion": 874,
        "descripcion": "Quimico en produccion de alcohol"
      },
      {
        "idOcupacion": 69,
        "descripcion": "Artificiero de explosivos - Militar"
      },
      {
        "idOcupacion": 471,
        "descripcion": "Fresador"
      },
      {
        "idOcupacion": 517,
        "descripcion": "Grabador de joyas"
      },
      {
        "idOcupacion": 314,
        "descripcion": "Desmoldeador"
      },
      {
        "idOcupacion": 774,
        "descripcion": "Pasajero aviacion comercial - autogiros"
      },
      {
        "idOcupacion": 861,
        "descripcion": "Promotor inmobiliario"
      },
      {
        "idOcupacion": 989,
        "descripcion": "Analista de selección de personal"
      },
      {
        "idOcupacion": 1010,
        "descripcion": "Cientifico bioquimico Administrativo"
      },
      {
        "idOcupacion": 410,
        "descripcion": "Entrega a domicilio en motocicleta"
      },
      {
        "idOcupacion": 654,
        "descripcion": "Juez"
      },
      {
        "idOcupacion": 110,
        "descripcion": "Aviacion comercial - Fumigador"
      },
      {
        "idOcupacion": 8,
        "descripcion": "Adiestrador animales domesticos"
      },
      {
        "idOcupacion": 288,
        "descripcion": "Costurera"
      },
      {
        "idOcupacion": 373,
        "descripcion": "Empleado bancario - Custodia o transporte de valores"
      },
      {
        "idOcupacion": 461,
        "descripcion": "Fogonero"
      },
      {
        "idOcupacion": 229,
        "descripcion": "Cientifico bioquimico"
      },
      {
        "idOcupacion": 467,
        "descripcion": "Fotografo en zona sin riesgo de conflicto"
      },
      {
        "idOcupacion": 786,
        "descripcion": "Perforador de pozos septicos"
      },
      {
        "idOcupacion": 62,
        "descripcion": "Arpista"
      },
      {
        "idOcupacion": 761,
        "descripcion": "Ornitologo"
      },
      {
        "idOcupacion": 1072,
        "descripcion": "Jefe de Ingenieria- Campo"
      },
      {
        "idOcupacion": 226,
        "descripcion": "Cientifico - Otros"
      },
      {
        "idOcupacion": 959,
        "descripcion": "Tricologo"
      },
      {
        "idOcupacion": 903,
        "descripcion": "Sacerdote en paises peligrosos"
      },
      {
        "idOcupacion": 197,
        "descripcion": "Cartero"
      },
      {
        "idOcupacion": 244,
        "descripcion": "Clerigo"
      },
      {
        "idOcupacion": 230,
        "descripcion": "Cientifico botanico"
      },
      {
        "idOcupacion": 476,
        "descripcion": "Fuerzas Armadas - Brigada antiterrorista"
      },
      {
        "idOcupacion": 697,
        "descripcion": "Mecanico de maquinaria pesada"
      },
      {
        "idOcupacion": 54,
        "descripcion": "Aprendiz de forjador de hierro"
      },
      {
        "idOcupacion": 730,
        "descripcion": "Moldeador"
      },
      {
        "idOcupacion": 343,
        "descripcion": "Director de zoologico"
      },
      {
        "idOcupacion": 442,
        "descripcion": "Fabricante de explosivos"
      },
      {
        "idOcupacion": 1053,
        "descripcion": "Ingeniero de ventilacion - Administrativo"
      },
      {
        "idOcupacion": 287,
        "descripcion": "Cosmetologo"
      },
      {
        "idOcupacion": 964,
        "descripcion": "Vedette / stripteasera / bailarina night club"
      },
      {
        "idOcupacion": 593,
        "descripcion": "Ingeniero de refrigeracion"
      },
      {
        "idOcupacion": 468,
        "descripcion": "Fraguador"
      },
      {
        "idOcupacion": 813,
        "descripcion": "Piloto Aviacion comercial - vuelo regular (transporte de pasajeros y carga)"
      },
      {
        "idOcupacion": 241,
        "descripcion": "Cirujano"
      },
      {
        "idOcupacion": 881,
        "descripcion": "Recaudador de impuestos"
      },
      {
        "idOcupacion": 339,
        "descripcion": "Director de periodico"
      },
      {
        "idOcupacion": 1092,
        "descripcion": "Mozo"
      },
      {
        "idOcupacion": 527,
        "descripcion": "Guardaparques"
      },
      {
        "idOcupacion": 329,
        "descripcion": "Diplomatico en paises o zonas sin peligros especiales"
      },
      {
        "idOcupacion": 345,
        "descripcion": "Directora de area"
      },
      {
        "idOcupacion": 296,
        "descripcion": "Cura en paises no peligrosos"
      },
      {
        "idOcupacion": 611,
        "descripcion": "Ingeniero mecanico"
      },
      {
        "idOcupacion": 1015,
        "descripcion": "Cientifico de laboratorio medico - Administrativo"
      },
      {
        "idOcupacion": 914,
        "descripcion": "Socorrista en mar"
      },
      {
        "idOcupacion": 75,
        "descripcion": "Aserrador - Amianto"
      },
      {
        "idOcupacion": 578,
        "descripcion": "Ingeniero de diseño"
      },
      {
        "idOcupacion": 743,
        "descripcion": "Musico de rock"
      },
      {
        "idOcupacion": 254,
        "descripcion": "Comercio en zona de conflicto o peligrosas"
      },
      {
        "idOcupacion": 163,
        "descripcion": "Cajista - Tipografia"
      },
      {
        "idOcupacion": 89,
        "descripcion": "Asistente medico"
      },
      {
        "idOcupacion": 518,
        "descripcion": "Grabador de sonido - Cinematografia - Entretenimiento"
      },
      {
        "idOcupacion": 587,
        "descripcion": "Ingeniero de minas - Tareas en superficie"
      },
      {
        "idOcupacion": 32,
        "descripcion": "Agente literario"
      },
      {
        "idOcupacion": 131,
        "descripcion": "Becario"
      },
      {
        "idOcupacion": 696,
        "descripcion": "Mecanico administrativo"
      },
      {
        "idOcupacion": 890,
        "descripcion": "Relojero"
      },
      {
        "idOcupacion": 435,
        "descripcion": "Expedicionario cientifico - Altas cumbres, volcanes, polos, selva y desiertos"
      },
      {
        "idOcupacion": 300,
        "descripcion": "Dean"
      },
      {
        "idOcupacion": 802,
        "descripcion": "Picapedrero - Canteria"
      },
      {
        "idOcupacion": 342,
        "descripcion": "Director de sanatorio de reposo"
      },
      {
        "idOcupacion": 238,
        "descripcion": "Cientifico meteorologo"
      },
      {
        "idOcupacion": 341,
        "descripcion": "Director de recursos humanos"
      },
      {
        "idOcupacion": 794,
        "descripcion": "Personal de aduana, frontera en zona de riesgo, inhospita"
      },
      {
        "idOcupacion": 734,
        "descripcion": "Monja/Monje/hermanas/hermanos"
      },
      {
        "idOcupacion": 971,
        "descripcion": "Vigilante / Guardia- con porta de armas"
      },
      {
        "idOcupacion": 185,
        "descripcion": "Capataz - Trabajos bajo tierra"
      },
      {
        "idOcupacion": 294,
        "descripcion": "Crupier"
      },
      {
        "idOcupacion": 1035,
        "descripcion": "Geologo - Campo"
      },
      {
        "idOcupacion": 927,
        "descripcion": "Tecnicas audiovisuales"
      },
      {
        "idOcupacion": 886,
        "descripcion": "Redactor"
      },
      {
        "idOcupacion": 264,
        "descripcion": "Consejero"
      },
      {
        "idOcupacion": 582,
        "descripcion": "Ingeniero de la construccion"
      },
      {
        "idOcupacion": 607,
        "descripcion": "Ingeniero geotecnica"
      },
      {
        "idOcupacion": 387,
        "descripcion": "Empleado en casa de cambio"
      },
      {
        "idOcupacion": 1121,
        "descripcion": "Tripulante Marina mercanteen zona sin riesgo"
      },
      {
        "idOcupacion": 220,
        "descripcion": "Chofer / Conductor de vehiculo de transporte de mercancias toxicas, inflamables o explosivas"
      },
      {
        "idOcupacion": 322,
        "descripcion": "Dibujante"
      },
      {
        "idOcupacion": 496,
        "descripcion": "Ganadero - Ganado bravo"
      },
      {
        "idOcupacion": 260,
        "descripcion": "Conductor de reparto/carga y descarga en moto"
      },
      {
        "idOcupacion": 351,
        "descripcion": "Doble"
      },
      {
        "idOcupacion": 584,
        "descripcion": "Ingeniero de lineas telefonicas"
      },
      {
        "idOcupacion": 200,
        "descripcion": "Catalogador"
      },
      {
        "idOcupacion": 535,
        "descripcion": "Herborista"
      },
      {
        "idOcupacion": 302,
        "descripcion": "Delineante"
      },
      {
        "idOcupacion": 278,
        "descripcion": "Corredor"
      },
      {
        "idOcupacion": 785,
        "descripcion": "Perforador"
      },
      {
        "idOcupacion": 520,
        "descripcion": "Granjero"
      },
      {
        "idOcupacion": 315,
        "descripcion": "Desmontador industrial"
      },
      {
        "idOcupacion": 1002,
        "descripcion": "Auditor financiero"
      },
      {
        "idOcupacion": 113,
        "descripcion": "Aviacion comercial -Extincion de fuegos"
      },
      {
        "idOcupacion": 1018,
        "descripcion": "Cientifico medico - Administrativo"
      },
      {
        "idOcupacion": 676,
        "descripcion": "Manicurista / pedicurista"
      },
      {
        "idOcupacion": 741,
        "descripcion": "Musico de jazz"
      },
      {
        "idOcupacion": 118,
        "descripcion": "Aviador militar - Piloto de helicoptero"
      },
      {
        "idOcupacion": 878,
        "descripcion": "Quiropractico"
      },
      {
        "idOcupacion": 603,
        "descripcion": "Ingeniero electronico"
      },
      {
        "idOcupacion": 559,
        "descripcion": "Industria petrolera - Plataforma petrolifera personal de vuelo"
      },
      {
        "idOcupacion": 692,
        "descripcion": "Matadero"
      },
      {
        "idOcupacion": 347,
        "descripcion": "Diseñador de interiores"
      },
      {
        "idOcupacion": 542,
        "descripcion": "Hojalatero"
      },
      {
        "idOcupacion": 198,
        "descripcion": "Cartografo"
      },
      {
        "idOcupacion": 674,
        "descripcion": "Mago"
      },
      {
        "idOcupacion": 619,
        "descripcion": "Instalador de cañerias"
      },
      {
        "idOcupacion": 153,
        "descripcion": "Buceo con uso de materiales peligrosos"
      },
      {
        "idOcupacion": 135,
        "descripcion": "Biologo"
      },
      {
        "idOcupacion": 845,
        "descripcion": "Profesional en servicios de estetica"
      },
      {
        "idOcupacion": 164,
        "descripcion": "Calador"
      },
      {
        "idOcupacion": 430,
        "descripcion": "Estudiante"
      },
      {
        "idOcupacion": 848,
        "descripcion": "Profesor de danza"
      },
      {
        "idOcupacion": 833,
        "descripcion": "Politico paises democraticos"
      },
      {
        "idOcupacion": 1119,
        "descripcion": "Trabajos 100% administrativos en campamento"
      },
      {
        "idOcupacion": 609,
        "descripcion": "Ingeniero hidraulico - ensamblaje y mantenimiento automoviles"
      },
      {
        "idOcupacion": 1051,
        "descripcion": "Ingeniero de television - Administrativo"
      },
      {
        "idOcupacion": 327,
        "descripcion": "Diplomatico en paises en guerra"
      },
      {
        "idOcupacion": 463,
        "descripcion": "Fontanero"
      },
      {
        "idOcupacion": 1099,
        "descripcion": "Pensionista"
      },
      {
        "idOcupacion": 988,
        "descripcion": "Analista comercial"
      },
      {
        "idOcupacion": 478,
        "descripcion": "Fuerzas Armadas - Desminadores"
      },
      {
        "idOcupacion": 56,
        "descripcion": "Arbitro"
      },
      {
        "idOcupacion": 152,
        "descripcion": "Buceo comercial offshore - sin uso de explosivos"
      },
      {
        "idOcupacion": 712,
        "descripcion": "Mezclador de sonido - Cinematografia - Entretenimiento"
      },
      {
        "idOcupacion": 932,
        "descripcion": "Tecnico en mantenimiento de ascensores"
      },
      {
        "idOcupacion": 1047,
        "descripcion": "Ingeniero de sistemas - Administrativo"
      },
      {
        "idOcupacion": 499,
        "descripcion": "Gasista - obrero"
      },
      {
        "idOcupacion": 283,
        "descripcion": "Corredor de reaseguros"
      },
      {
        "idOcupacion": 162,
        "descripcion": "Cajero"
      },
      {
        "idOcupacion": 419,
        "descripcion": "Escritor"
      },
      {
        "idOcupacion": 384,
        "descripcion": "Empleado de embajada"
      },
      {
        "idOcupacion": 920,
        "descripcion": "Suscriptor, tarificador, seleccionador de riesgos"
      },
      {
        "idOcupacion": 266,
        "descripcion": "Conserje de vivienda"
      },
      {
        "idOcupacion": 259,
        "descripcion": "Conductor de Ferrocarriles - Locomotora"
      },
      {
        "idOcupacion": 462,
        "descripcion": "Fonoaudiologo"
      },
      {
        "idOcupacion": 104,
        "descripcion": "Auxiliar de vuelo / aeromozo o aeromoza - Vuelo regular"
      },
      {
        "idOcupacion": 139,
        "descripcion": "Bioquimico industrial"
      },
      {
        "idOcupacion": 803,
        "descripcion": "Piloto / Instructor de vuelo aviacion comercial"
      },
      {
        "idOcupacion": 762,
        "descripcion": "Ortopeda"
      },
      {
        "idOcupacion": 962,
        "descripcion": "Tripulacion y pasajeros aviacion comercial - helicoptero"
      },
      {
        "idOcupacion": 953,
        "descripcion": "Transporte de mercancias peligrosas /toxicas/inflamables/explosivas)"
      },
      {
        "idOcupacion": 664,
        "descripcion": "Limpiador de gemas"
      },
      {
        "idOcupacion": 718,
        "descripcion": "Mineralogista"
      },
      {
        "idOcupacion": 224,
        "descripcion": "Cientifico"
      },
      {
        "idOcupacion": 44,
        "descripcion": "Analista de inversiones"
      },
      {
        "idOcupacion": 485,
        "descripcion": "Fumigador - Aviacion comercial"
      },
      {
        "idOcupacion": 822,
        "descripcion": "Poeta"
      },
      {
        "idOcupacion": 39,
        "descripcion": "Albañil de tuneles"
      },
      {
        "idOcupacion": 639,
        "descripcion": "Instructor - profesor de tenis"
      },
      {
        "idOcupacion": 415,
        "descripcion": "Entrenador deportivo"
      },
      {
        "idOcupacion": 10,
        "descripcion": "Adiestrador de perros"
      },
      {
        "idOcupacion": 483,
        "descripcion": "Fuerzas especiales - Brigada antiterrorista"
      },
      {
        "idOcupacion": 742,
        "descripcion": "Musico de orquesta"
      },
      {
        "idOcupacion": 211,
        "descripcion": "Chatarrero"
      },
      {
        "idOcupacion": 915,
        "descripcion": "Socorrista piscina"
      },
      {
        "idOcupacion": 406,
        "descripcion": "Enmarcador de fotografias/cuadros"
      },
      {
        "idOcupacion": 82,
        "descripcion": "Asesor"
      },
      {
        "idOcupacion": 722,
        "descripcion": "Minero - Tareas en superficie"
      },
      {
        "idOcupacion": 949,
        "descripcion": "Traga fuego"
      },
      {
        "idOcupacion": 780,
        "descripcion": "Payaso"
      },
      {
        "idOcupacion": 205,
        "descripcion": "Censor"
      },
      {
        "idOcupacion": 963,
        "descripcion": "Trombonista"
      },
      {
        "idOcupacion": 270,
        "descripcion": "Contador"
      },
      {
        "idOcupacion": 31,
        "descripcion": "Agente Inmobiliario"
      },
      {
        "idOcupacion": 160,
        "descripcion": "Caballerizo"
      },
      {
        "idOcupacion": 206,
        "descripcion": "Censor jurado de cuentas"
      },
      {
        "idOcupacion": 428,
        "descripcion": "Estibador"
      },
      {
        "idOcupacion": 900,
        "descripcion": "Revisor"
      },
      {
        "idOcupacion": 805,
        "descripcion": "Piloto Aviacion comercial - Alumno"
      },
      {
        "idOcupacion": 675,
        "descripcion": "Malabarista"
      },
      {
        "idOcupacion": 191,
        "descripcion": "Capitan - Pesquero en costas, rios y lagos"
      },
      {
        "idOcupacion": 425,
        "descripcion": "Esteticista"
      },
      {
        "idOcupacion": 727,
        "descripcion": "Modelador - Textil"
      },
      {
        "idOcupacion": 58,
        "descripcion": "Arborista"
      },
      {
        "idOcupacion": 398,
        "descripcion": "Encuadernador de imprenta"
      },
      {
        "idOcupacion": 720,
        "descripcion": "Minero - Manejo de explosivos"
      },
      {
        "idOcupacion": 924,
        "descripcion": "Tasador - Excepto ganado"
      },
      {
        "idOcupacion": 868,
        "descripcion": "Psicometrista"
      },
      {
        "idOcupacion": 1049,
        "descripcion": "Ingeniero de suelos - Administrativo"
      },
      {
        "idOcupacion": 566,
        "descripcion": "Ingeniero - hidrografico"
      },
      {
        "idOcupacion": 541,
        "descripcion": "Hipnotizador - Entretenimiento"
      },
      {
        "idOcupacion": 736,
        "descripcion": "Montador de vigas"
      },
      {
        "idOcupacion": 516,
        "descripcion": "Grabador de datos"
      },
      {
        "idOcupacion": 832,
        "descripcion": "Politico en zonas de conflicto"
      },
      {
        "idOcupacion": 1008,
        "descripcion": "Cientifico agricola - Administrativo"
      },
      {
        "idOcupacion": 710,
        "descripcion": "Mezclador de doblaje"
      },
      {
        "idOcupacion": 1056,
        "descripcion": "Ingeniero en campo"
      },
      {
        "idOcupacion": 3,
        "descripcion": "Acrobata - Circo"
      },
      {
        "idOcupacion": 232,
        "descripcion": "Cientifico de investigacion de operaciones"
      },
      {
        "idOcupacion": 1095,
        "descripcion": "Obrero colocador de vidrios en altura"
      },
      {
        "idOcupacion": 534,
        "descripcion": "Hematologo"
      },
      {
        "idOcupacion": 65,
        "descripcion": "Arquitecto"
      },
      {
        "idOcupacion": 908,
        "descripcion": "Secretaria"
      },
      {
        "idOcupacion": 420,
        "descripcion": "Escultor"
      },
      {
        "idOcupacion": 601,
        "descripcion": "Ingeniero de video"
      },
      {
        "idOcupacion": 982,
        "descripcion": "Administrativo dentro de campamento minero"
      },
      {
        "idOcupacion": 671,
        "descripcion": "Maestro de danza"
      },
      {
        "idOcupacion": 768,
        "descripcion": "Paleontologo"
      },
      {
        "idOcupacion": 504,
        "descripcion": "Geofisico"
      },
      {
        "idOcupacion": 726,
        "descripcion": "Misionera/Misionero en paises peligrosos"
      },
      {
        "idOcupacion": 648,
        "descripcion": "Interprete"
      },
      {
        "idOcupacion": 253,
        "descripcion": "Comerciante en zona segura"
      },
      {
        "idOcupacion": 132,
        "descripcion": "Bibliografo"
      },
      {
        "idOcupacion": 1000,
        "descripcion": "Auditor administrativo"
      },
      {
        "idOcupacion": 166,
        "descripcion": "Calderero de alquitran"
      },
      {
        "idOcupacion": 694,
        "descripcion": "Mayordomo"
      },
      {
        "idOcupacion": 298,
        "descripcion": "Curtidor"
      },
      {
        "idOcupacion": 568,
        "descripcion": "Ingeniero aeronautico"
      },
      {
        "idOcupacion": 233,
        "descripcion": "Cientifico de laboratorio"
      },
      {
        "idOcupacion": 472,
        "descripcion": "Fruticultor"
      },
      {
        "idOcupacion": 620,
        "descripcion": "Instalador de computadores"
      },
      {
        "idOcupacion": 956,
        "descripcion": "Trapecista con red - Circo"
      },
      {
        "idOcupacion": 904,
        "descripcion": "Sacristan"
      },
      {
        "idOcupacion": 557,
        "descripcion": "Industria petrolera - Mantenimiento de cubas o tanques de almacenamiento"
      },
      {
        "idOcupacion": 946,
        "descripcion": "Traductor"
      },
      {
        "idOcupacion": 276,
        "descripcion": "Coreografo"
      },
      {
        "idOcupacion": 38,
        "descripcion": "Albañil de puente"
      },
      {
        "idOcupacion": 825,
        "descripcion": "Policia - Brigada narcotrafico"
      },
      {
        "idOcupacion": 795,
        "descripcion": "Personal de aduana, frontera en zona sin riesgo especial"
      },
      {
        "idOcupacion": 782,
        "descripcion": "Peletero / Fabricante o vendedor prendas de piel"
      },
      {
        "idOcupacion": 623,
        "descripcion": "Instalador de telefonos"
      },
      {
        "idOcupacion": 777,
        "descripcion": "Pasajero aviacion comercial - vuelo no regular (transporte de carga y pasajeros)"
      },
      {
        "idOcupacion": 482,
        "descripcion": "Fuerzas Armadas - Tareas administrativas"
      },
      {
        "idOcupacion": 993,
        "descripcion": "Arqueologo - Administrativo"
      },
      {
        "idOcupacion": 1088,
        "descripcion": "Medico Administrador"
      },
      {
        "idOcupacion": 297,
        "descripcion": "Curador holista"
      },
      {
        "idOcupacion": 595,
        "descripcion": "Ingeniero de software"
      },
      {
        "idOcupacion": 866,
        "descripcion": "Psicologo clinico"
      },
      {
        "idOcupacion": 628,
        "descripcion": "Instructor - Buceo comercial"
      },
      {
        "idOcupacion": 407,
        "descripcion": "Ensamblador / Montador de maquinaria industrial"
      },
      {
        "idOcupacion": 663,
        "descripcion": "Limnologo"
      },
      {
        "idOcupacion": 695,
        "descripcion": "Mecanico"
      },
      {
        "idOcupacion": 905,
        "descripcion": "Salvavidas en mar"
      },
      {
        "idOcupacion": 586,
        "descripcion": "Ingeniero de minas - Tareas bajo tierra"
      },
      {
        "idOcupacion": 995,
        "descripcion": "Asesor financiero"
      },
      {
        "idOcupacion": 169,
        "descripcion": "Camarera"
      },
      {
        "idOcupacion": 767,
        "descripcion": "Paisajista"
      },
      {
        "idOcupacion": 1116,
        "descripcion": "Supervisor Operaciones Administrativo"
      },
      {
        "idOcupacion": 787,
        "descripcion": "Perforista / especialista manejo maquinas perforadoras"
      },
      {
        "idOcupacion": 383,
        "descripcion": "Empleado de carga de ferrocarril"
      },
      {
        "idOcupacion": 332,
        "descripcion": "Director - Equipo deportivo - Tiempo parcial"
      },
      {
        "idOcupacion": 731,
        "descripcion": "Moldeador de ceramica"
      },
      {
        "idOcupacion": 363,
        "descripcion": "Electricista - Tendidos electricos alta tension"
      },
      {
        "idOcupacion": 215,
        "descripcion": "Chef"
      },
      {
        "idOcupacion": 773,
        "descripcion": "Parroco"
      },
      {
        "idOcupacion": 488,
        "descripcion": "Funcionariado - Solo administracion"
      },
      {
        "idOcupacion": 96,
        "descripcion": "Audiologo"
      },
      {
        "idOcupacion": 388,
        "descripcion": "Empleado industria automovilistica"
      },
      {
        "idOcupacion": 321,
        "descripcion": "Diacono"
      },
      {
        "idOcupacion": 210,
        "descripcion": "Charcutero"
      },
      {
        "idOcupacion": 850,
        "descripcion": "Profesor de gimnasia/aerobics"
      },
      {
        "idOcupacion": 817,
        "descripcion": "Pintor estructuras metalicas en altura"
      },
      {
        "idOcupacion": 651,
        "descripcion": "Jardinero"
      },
      {
        "idOcupacion": 530,
        "descripcion": "Guia museos / edificio historico"
      },
      {
        "idOcupacion": 323,
        "descripcion": "Dietista"
      },
      {
        "idOcupacion": 622,
        "descripcion": "Instalador de sistemas informaticos"
      },
      {
        "idOcupacion": 981,
        "descripcion": "Acrobata - Tierra"
      },
      {
        "idOcupacion": 869,
        "descripcion": "Psiquiatra"
      },
      {
        "idOcupacion": 1032,
        "descripcion": "Gasfitero"
      },
      {
        "idOcupacion": 385,
        "descripcion": "Empleado de estacionamiento/ aparcamiento"
      },
      {
        "idOcupacion": 1077,
        "descripcion": "Labores Administrativas en oficina en ciudad"
      },
      {
        "idOcupacion": 421,
        "descripcion": "Eslingador / Dirigir operaciones de gruas"
      },
      {
        "idOcupacion": 625,
        "descripcion": "Instructor - Aerobico"
      },
      {
        "idOcupacion": 221,
        "descripcion": "Chofer / Conductor maquinaria pesada"
      },
      {
        "idOcupacion": 940,
        "descripcion": "Torero"
      },
      {
        "idOcupacion": 700,
        "descripcion": "Medico"
      },
      {
        "idOcupacion": 181,
        "descripcion": "Cantero"
      },
      {
        "idOcupacion": 649,
        "descripcion": "Investigador privado - sin armas"
      },
      {
        "idOcupacion": 460,
        "descripcion": "Florista"
      },
      {
        "idOcupacion": 1014,
        "descripcion": "Cientifico de laboratorio  - Administrativo"
      },
      {
        "idOcupacion": 477,
        "descripcion": "Fuerzas Armadas - Brigada narcotrafico"
      },
      {
        "idOcupacion": 629,
        "descripcion": "Instructor - Buceo militar"
      },
      {
        "idOcupacion": 178,
        "descripcion": "Cantante de jazz"
      },
      {
        "idOcupacion": 672,
        "descripcion": "Maestro de obras"
      },
      {
        "idOcupacion": 1082,
        "descripcion": "Marina mercante en zona sin riesgo"
      },
      {
        "idOcupacion": 606,
        "descripcion": "Ingeniero forestal"
      },
      {
        "idOcupacion": 823,
        "descripcion": "Policia - Administrativo"
      },
      {
        "idOcupacion": 404,
        "descripcion": "Engarzador de gemas"
      },
      {
        "idOcupacion": 123,
        "descripcion": "Bacteriologo"
      },
      {
        "idOcupacion": 624,
        "descripcion": "Instalador/reparador de telefonos"
      },
      {
        "idOcupacion": 781,
        "descripcion": "Pedicura"
      },
      {
        "idOcupacion": 414,
        "descripcion": "Entrenador de gimnasia deportivo profesional"
      },
      {
        "idOcupacion": 684,
        "descripcion": "Manipulador de sustancias corrosivas, toxicas"
      },
      {
        "idOcupacion": 381,
        "descripcion": "Empleado de calderas - edificios y fabricas"
      },
      {
        "idOcupacion": 151,
        "descripcion": "Buceo comercial offshore - con uso de explosivos"
      },
      {
        "idOcupacion": 317,
        "descripcion": "Detective privado - con uso de armas"
      },
      {
        "idOcupacion": 274,
        "descripcion": "Controlador de calidad"
      },
      {
        "idOcupacion": 417,
        "descripcion": "Escaparatista / Diseño de vitrinas"
      },
      {
        "idOcupacion": 760,
        "descripcion": "Organista"
      },
      {
        "idOcupacion": 268,
        "descripcion": "Consultor - Direccion"
      },
      {
        "idOcupacion": 228,
        "descripcion": "Cientifico biologo"
      },
      {
        "idOcupacion": 950,
        "descripcion": "Tramoyista"
      },
      {
        "idOcupacion": 714,
        "descripcion": "Micologo"
      },
      {
        "idOcupacion": 81,
        "descripcion": "Aserrador - Metales"
      },
      {
        "idOcupacion": 2,
        "descripcion": "Acomodador - Eventos deportivos y musicales"
      },
      {
        "idOcupacion": 433,
        "descripcion": "Etnomusicologo"
      },
      {
        "idOcupacion": 194,
        "descripcion": "Carnicero"
      },
      {
        "idOcupacion": 562,
        "descripcion": "Industria petroquimica - Plataforma petrolifera empleados que realizan otras funciones"
      },
      {
        "idOcupacion": 604,
        "descripcion": "Ingeniero en computacion"
      },
      {
        "idOcupacion": 1089,
        "descripcion": "Medico Ocupacional"
      },
      {
        "idOcupacion": 670,
        "descripcion": "Logopeda"
      },
      {
        "idOcupacion": 120,
        "descripcion": "Aviador militar - tripulacion, pasajeros de aviones militares"
      },
      {
        "idOcupacion": 650,
        "descripcion": "Investigador privado - uso de armas"
      },
      {
        "idOcupacion": 738,
        "descripcion": "Montador y moldeador - Procesamiento de metales"
      },
      {
        "idOcupacion": 1122,
        "descripcion": "Wedding Planner"
      },
      {
        "idOcupacion": 292,
        "descripcion": "Cristalero"
      },
      {
        "idOcupacion": 330,
        "descripcion": "Directivo"
      },
      {
        "idOcupacion": 21,
        "descripcion": "Agente"
      },
      {
        "idOcupacion": 484,
        "descripcion": "Fuerzas especiales - Brigada narcotrafico"
      },
      {
        "idOcupacion": 231,
        "descripcion": "Cientifico de ciencias naturales"
      },
      {
        "idOcupacion": 519,
        "descripcion": "Grabador de sonido - Industria musical - Entretenimiento"
      },
      {
        "idOcupacion": 592,
        "descripcion": "Ingeniero de radio"
      },
      {
        "idOcupacion": 702,
        "descripcion": "Mensajero - Trabajo en oficina / Administrativo"
      },
      {
        "idOcupacion": 344,
        "descripcion": "Director musical"
      },
      {
        "idOcupacion": 1022,
        "descripcion": "Enfermera"
      },
      {
        "idOcupacion": 1009,
        "descripcion": "Cientifico biologo Administrativo"
      },
      {
        "idOcupacion": 1118,
        "descripcion": "Terapista - Rehabilitacion"
      },
      {
        "idOcupacion": 183,
        "descripcion": "Cantinero (excepto centros nocturnos)"
      },
      {
        "idOcupacion": 1113,
        "descripcion": "Supervisor de campo"
      },
      {
        "idOcupacion": 645,
        "descripcion": "Instructor de danza"
      },
      {
        "idOcupacion": 831,
        "descripcion": "Policia de fronteras, gendarmeria"
      },
      {
        "idOcupacion": 565,
        "descripcion": "Informatico"
      },
      {
        "idOcupacion": 40,
        "descripcion": "Alfarero"
      },
      {
        "idOcupacion": 657,
        "descripcion": "Laminador"
      },
      {
        "idOcupacion": 265,
        "descripcion": "Conserje"
      },
      {
        "idOcupacion": 610,
        "descripcion": "Ingeniero Industrial"
      },
      {
        "idOcupacion": 14,
        "descripcion": "Administrador de empresas"
      },
      {
        "idOcupacion": 291,
        "descripcion": "Criador de perros de combate"
      },
      {
        "idOcupacion": 1079,
        "descripcion": "Marina mercante  mecanico en barco en zona sin riesgo"
      },
      {
        "idOcupacion": 289,
        "descripcion": "Criador de animales domesticos"
      },
      {
        "idOcupacion": 1064,
        "descripcion": "Ingeniero nuclear - Administrativo"
      },
      {
        "idOcupacion": 1108,
        "descripcion": "Rentista"
      },
      {
        "idOcupacion": 810,
        "descripcion": "Piloto aviacion comercial - escuela de aviacion"
      },
      {
        "idOcupacion": 308,
        "descripcion": "Desatascador de desagues"
      },
      {
        "idOcupacion": 208,
        "descripcion": "Cerrajero"
      },
      {
        "idOcupacion": 991,
        "descripcion": "Apicultor - Administrativo"
      },
      {
        "idOcupacion": 203,
        "descripcion": "Cazador menor"
      },
      {
        "idOcupacion": 55,
        "descripcion": "Arbitrador"
      },
      {
        "idOcupacion": 352,
        "descripcion": "Domador de caballos"
      },
      {
        "idOcupacion": 549,
        "descripcion": "Impresor"
      },
      {
        "idOcupacion": 855,
        "descripcion": "Profesor instituciones educativas"
      },
      {
        "idOcupacion": 399,
        "descripcion": "Encuadernador de libros"
      },
      {
        "idOcupacion": 608,
        "descripcion": "Ingeniero grafico"
      },
      {
        "idOcupacion": 18,
        "descripcion": "Afinador de instrumentos"
      },
      {
        "idOcupacion": 309,
        "descripcion": "Descargador"
      },
      {
        "idOcupacion": 390,
        "descripcion": "Empleado industria bioquimica - Investigador"
      },
      {
        "idOcupacion": 599,
        "descripcion": "Ingeniero de ventas"
      },
      {
        "idOcupacion": 493,
        "descripcion": "Galvanotipista"
      },
      {
        "idOcupacion": 724,
        "descripcion": "Ministro"
      },
      {
        "idOcupacion": 263,
        "descripcion": "Conductor otros vehiculos"
      },
      {
        "idOcupacion": 1034,
        "descripcion": "Geologo  - Administrativo en Ciudad"
      },
      {
        "idOcupacion": 219,
        "descripcion": "Chofer / Conductor- Buses/minibuses"
      },
      {
        "idOcupacion": 1061,
        "descripcion": "Ingeniero Labores administrarivas en ciudad"
      },
      {
        "idOcupacion": 239,
        "descripcion": "Cientifico nuclear"
      },
      {
        "idOcupacion": 646,
        "descripcion": "Instructor de patinaje sobre hielo"
      },
      {
        "idOcupacion": 448,
        "descripcion": "Fabricante productos de hierro, acero"
      },
      {
        "idOcupacion": 941,
        "descripcion": "Tornero"
      },
      {
        "idOcupacion": 100,
        "descripcion": "Auxiliar de clinica veterinaria"
      },
      {
        "idOcupacion": 934,
        "descripcion": "Tendedor de vias de ferrocarril"
      },
      {
        "idOcupacion": 561,
        "descripcion": "Industria petrolera - Vigilante de refineria"
      },
      {
        "idOcupacion": 261,
        "descripcion": "Conductor de vehiculo de transporte de mercancias no peligrosas"
      },
      {
        "idOcupacion": 1100,
        "descripcion": "Petrolero y gasero marina mercante en zona sin riesgo"
      },
      {
        "idOcupacion": 870,
        "descripcion": "Publicista"
      },
      {
        "idOcupacion": 877,
        "descripcion": "Quimico nuclear"
      },
      {
        "idOcupacion": 155,
        "descripcion": "Buceo profesional - buceo en barcos hundidos ingreso total al interior"
      },
      {
        "idOcupacion": 138,
        "descripcion": "Bioquimico farmaceutico"
      },
      {
        "idOcupacion": 642,
        "descripcion": "Instructor de ballet"
      },
      {
        "idOcupacion": 661,
        "descripcion": "Lepidopterista / Estudio de las mariposas"
      },
      {
        "idOcupacion": 621,
        "descripcion": "Instalador de gas"
      },
      {
        "idOcupacion": 170,
        "descripcion": "Camarero bar, cantina, pub (excepto centros nocturnos)"
      },
      {
        "idOcupacion": 933,
        "descripcion": "Telefonia - Instalador de tendidos aereos"
      },
      {
        "idOcupacion": 108,
        "descripcion": "Aviacion Civil y Comercial"
      },
      {
        "idOcupacion": 957,
        "descripcion": "Trapecista sin red - Circo"
      },
      {
        "idOcupacion": 638,
        "descripcion": "Instructor - Preparacion fisica/Gimnasia"
      },
      {
        "idOcupacion": 643,
        "descripcion": "Instructor de Canoa y Kayak"
      },
      {
        "idOcupacion": 246,
        "descripcion": "Cobrador en zonas peligrosas o conflictivas"
      },
      {
        "idOcupacion": 128,
        "descripcion": "Barbero"
      },
      {
        "idOcupacion": 480,
        "descripcion": "Fuerzas Armadas - Guardacostas"
      },
      {
        "idOcupacion": 699,
        "descripcion": "Mecanicos motociclismo en circuito"
      },
      {
        "idOcupacion": 202,
        "descripcion": "Cazador mayor"
      },
      {
        "idOcupacion": 98,
        "descripcion": "Auditor"
      },
      {
        "idOcupacion": 85,
        "descripcion": "Asfaltador"
      },
      {
        "idOcupacion": 423,
        "descripcion": "Estenografo"
      },
      {
        "idOcupacion": 750,
        "descripcion": "Obreros en centrales nucleares"
      },
      {
        "idOcupacion": 511,
        "descripcion": "Geoquimico"
      },
      {
        "idOcupacion": 95,
        "descripcion": "Au Pair"
      },
      {
        "idOcupacion": 1105,
        "descripcion": "Policial y Buceo cientifico  - sin uso de explosivos"
      },
      {
        "idOcupacion": 615,
        "descripcion": "Inseminador de ganado"
      },
      {
        "idOcupacion": 889,
        "descripcion": "Rejoneador"
      },
      {
        "idOcupacion": 766,
        "descripcion": "Otra profesion no listada"
      },
      {
        "idOcupacion": 635,
        "descripcion": "Instructor - Esqui acuatico"
      },
      {
        "idOcupacion": 612,
        "descripcion": "Ingeniero nuclear"
      },
      {
        "idOcupacion": 124,
        "descripcion": "Bailarin / Bailarina profesional"
      },
      {
        "idOcupacion": 538,
        "descripcion": "Hidrobiologo"
      },
      {
        "idOcupacion": 1110,
        "descripcion": "Supervisor Almacenes - Explosivos"
      },
      {
        "idOcupacion": 846,
        "descripcion": "Profesor"
      },
      {
        "idOcupacion": 165,
        "descripcion": "Calderero"
      },
      {
        "idOcupacion": 142,
        "descripcion": "Bombero - Extincion de fuego desde el aire"
      },
      {
        "idOcupacion": 25,
        "descripcion": "Agente de cambio informal"
      },
      {
        "idOcupacion": 285,
        "descripcion": "Cortador de metales / metalurgia"
      },
      {
        "idOcupacion": 531,
        "descripcion": "Guia turistico"
      },
      {
        "idOcupacion": 509,
        "descripcion": "Geologo de ingenieria"
      },
      {
        "idOcupacion": 201,
        "descripcion": "Catedratico"
      },
      {
        "idOcupacion": 340,
        "descripcion": "Director de personal"
      },
      {
        "idOcupacion": 12,
        "descripcion": "Administrador"
      },
      {
        "idOcupacion": 918,
        "descripcion": "Submarinista (exploracion submarina comercial, cientifica o militar)"
      },
      {
        "idOcupacion": 338,
        "descripcion": "Director de equipo de tecnicos de giras artisticas"
      },
      {
        "idOcupacion": 779,
        "descripcion": "Patronista textil"
      },
      {
        "idOcupacion": 1093,
        "descripcion": "Mozo de restaurante"
      },
      {
        "idOcupacion": 9,
        "descripcion": "Adiestrador de fieras"
      },
      {
        "idOcupacion": 838,
        "descripcion": "Presidente - Empresa"
      },
      {
        "idOcupacion": 812,
        "descripcion": "Piloto aviacion comercial - vuelo no regular (transporte de pasajeros y carga)"
      },
      {
        "idOcupacion": 594,
        "descripcion": "Ingeniero de sistemas"
      },
      {
        "idOcupacion": 707,
        "descripcion": "Metalurgico"
      },
      {
        "idOcupacion": 937,
        "descripcion": "Tesorero"
      },
      {
        "idOcupacion": 173,
        "descripcion": "Camarografo en zona de conflicto"
      },
      {
        "idOcupacion": 53,
        "descripcion": "Aprendiz de forjador"
      },
      {
        "idOcupacion": 324,
        "descripcion": "Digitador"
      },
      {
        "idOcupacion": 255,
        "descripcion": "Comercio en zona segura"
      },
      {
        "idOcupacion": 1065,
        "descripcion": "Ingeniero produccion de armas - Administrativo"
      },
      {
        "idOcupacion": 97,
        "descripcion": "Audiometrista"
      },
      {
        "idOcupacion": 514,
        "descripcion": "Ginecologo"
      },
      {
        "idOcupacion": 683,
        "descripcion": "Manipulador de residuos patologicos"
      },
      {
        "idOcupacion": 928,
        "descripcion": "Tecnico - Laboratorio"
      },
      {
        "idOcupacion": 489,
        "descripcion": "Funcionariado del gobierno - Solamente administracion"
      },
      {
        "idOcupacion": 799,
        "descripcion": "Picador de carbon"
      },
      {
        "idOcupacion": 199,
        "descripcion": "Catador"
      },
      {
        "idOcupacion": 1023,
        "descripcion": "Escultor - Administrativo"
      },
      {
        "idOcupacion": 867,
        "descripcion": "Psicologo educacional"
      },
      {
        "idOcupacion": 634,
        "descripcion": "Instructor - Esqui"
      },
      {
        "idOcupacion": 209,
        "descripcion": "Cervecero"
      },
      {
        "idOcupacion": 52,
        "descripcion": "Apicultor"
      },
      {
        "idOcupacion": 27,
        "descripcion": "Agente de Seguros"
      },
      {
        "idOcupacion": 1058,
        "descripcion": "Ingeniero en informatica - Administrativo"
      },
      {
        "idOcupacion": 225,
        "descripcion": "Cientifico - No materiales explosivos/radiactivos"
      },
      {
        "idOcupacion": 856,
        "descripcion": "Programador"
      },
      {
        "idOcupacion": 523,
        "descripcion": "Guardabosques"
      },
      {
        "idOcupacion": 656,
        "descripcion": "Jurista"
      },
      {
        "idOcupacion": 801,
        "descripcion": "Picapedrero - Cantera"
      },
      {
        "idOcupacion": 4,
        "descripcion": "Actor"
      },
      {
        "idOcupacion": 394,
        "descripcion": "Empleado industria maderera"
      },
      {
        "idOcupacion": 111,
        "descripcion": "Aviacion comercial - Piloto de prueba"
      },
      {
        "idOcupacion": 393,
        "descripcion": "Empleado industria farmaceutica - Investigador"
      },
      {
        "idOcupacion": 376,
        "descripcion": "Empleado centro nocturno"
      },
      {
        "idOcupacion": 161,
        "descripcion": "Cabaretista"
      },
      {
        "idOcupacion": 809,
        "descripcion": "Piloto Aviacion comercial - Dirigibles"
      },
      {
        "idOcupacion": 1001,
        "descripcion": "Auditor contable"
      },
      {
        "idOcupacion": 842,
        "descripcion": "Productor/fabricante de alcohol"
      },
      {
        "idOcupacion": 764,
        "descripcion": "Otologo"
      },
      {
        "idOcupacion": 860,
        "descripcion": "Promotor deportivo"
      },
      {
        "idOcupacion": 26,
        "descripcion": "Agente de cambio legalmente establecidos"
      },
      {
        "idOcupacion": 872,
        "descripcion": "Puericultor/ Puericultura"
      },
      {
        "idOcupacion": 13,
        "descripcion": "Administrador de circo"
      },
      {
        "idOcupacion": 437,
        "descripcion": "Extinguidor de incendios con aviones"
      },
      {
        "idOcupacion": 1085,
        "descripcion": "Mecanico de autos"
      },
      {
        "idOcupacion": 280,
        "descripcion": "Corredor de apuestas / Agencia de apuestas"
      },
      {
        "idOcupacion": 887,
        "descripcion": "Reflexologo"
      },
      {
        "idOcupacion": 267,
        "descripcion": "Consul"
      },
      {
        "idOcupacion": 277,
        "descripcion": "Corrector de pruebas"
      },
      {
        "idOcupacion": 190,
        "descripcion": "Capitan - Pesquero en alta mar"
      },
      {
        "idOcupacion": 447,
        "descripcion": "Fabricante industrial de pinturas"
      },
      {
        "idOcupacion": 375,
        "descripcion": "Empleado centrales nucleares"
      },
      {
        "idOcupacion": 1050,
        "descripcion": "Ingeniero de telecomunicaciones - Administrativo"
      },
      {
        "idOcupacion": 127,
        "descripcion": "Bar trabajos generales"
      },
      {
        "idOcupacion": 807,
        "descripcion": "Piloto aviacion comercial - cartografia aerea"
      },
      {
        "idOcupacion": 821,
        "descripcion": "Pocero / Fabricador y limpiador de pozos septicos"
      },
      {
        "idOcupacion": 547,
        "descripcion": "Ilusionista"
      },
      {
        "idOcupacion": 571,
        "descripcion": "Ingeniero civil"
      },
      {
        "idOcupacion": 875,
        "descripcion": "Quimico fisico"
      },
      {
        "idOcupacion": 452,
        "descripcion": "Filologo"
      },
      {
        "idOcupacion": 454,
        "descripcion": "Fiscal"
      },
      {
        "idOcupacion": 119,
        "descripcion": "Aviador militar - piloto de pruebas"
      },
      {
        "idOcupacion": 588,
        "descripcion": "Ingeniero de petroleos"
      },
      {
        "idOcupacion": 487,
        "descripcion": "Fumigador terrestre"
      },
      {
        "idOcupacion": 16,
        "descripcion": "Administrativo"
      },
      {
        "idOcupacion": 240,
        "descripcion": "Cientifico nuclear de central de energia atomica"
      },
      {
        "idOcupacion": 1107,
        "descripcion": "Recursos Humanos"
      },
      {
        "idOcupacion": 644,
        "descripcion": "Instructor de Canyoning"
      },
      {
        "idOcupacion": 647,
        "descripcion": "Instructor de squash"
      },
      {
        "idOcupacion": 248,
        "descripcion": "Cocinero/cocinera"
      },
      {
        "idOcupacion": 898,
        "descripcion": "Restaurador - Tapices"
      },
      {
        "idOcupacion": 1070,
        "descripcion": "Jefe administrativo"
      },
      {
        "idOcupacion": 798,
        "descripcion": "Picador - toros"
      },
      {
        "idOcupacion": 729,
        "descripcion": "Modista"
      },
      {
        "idOcupacion": 506,
        "descripcion": "Geologo - Mineria"
      },
      {
        "idOcupacion": 631,
        "descripcion": "Instructor - Ciclismo"
      },
      {
        "idOcupacion": 271,
        "descripcion": "Contorsionista"
      },
      {
        "idOcupacion": 491,
        "descripcion": "Funcionarios Cuerpos y Fuerzas de Seguridad del Estado"
      },
      {
        "idOcupacion": 602,
        "descripcion": "Ingeniero electrico"
      },
      {
        "idOcupacion": 486,
        "descripcion": "Fumigador aereo"
      },
      {
        "idOcupacion": 711,
        "descripcion": "Mezclador de sonido"
      },
      {
        "idOcupacion": 626,
        "descripcion": "Instructor - Artes marciales contacto parcial o contacto total"
      },
      {
        "idOcupacion": 312,
        "descripcion": "Deshollinador (mas de 15 metros)"
      },
      {
        "idOcupacion": 994,
        "descripcion": "Asesor Administrativo"
      },
      {
        "idOcupacion": 301,
        "descripcion": "Decorador"
      },
      {
        "idOcupacion": 576,
        "descripcion": "Ingeniero de automoviles - ensamblaje y mantenimiento"
      },
      {
        "idOcupacion": 86,
        "descripcion": "Asfaltador - Mantenimiento y construccion de carreteras"
      },
      {
        "idOcupacion": 793,
        "descripcion": "Personal administrativo"
      },
      {
        "idOcupacion": 853,
        "descripcion": "Profesor de yoga"
      },
      {
        "idOcupacion": 1080,
        "descripcion": "Marina mercante  petrolero y gasero en zona sin riesgo"
      },
      {
        "idOcupacion": 570,
        "descripcion": "Ingeniero agronomo"
      },
      {
        "idOcupacion": 1120,
        "descripcion": "Trabajos 100% administrativos oficina"
      },
      {
        "idOcupacion": 1025,
        "descripcion": "Financista"
      },
      {
        "idOcupacion": 252,
        "descripcion": "Comerciante en zona de conflicto o peligrosa"
      },
      {
        "idOcupacion": 465,
        "descripcion": "Forjador"
      },
      {
        "idOcupacion": 80,
        "descripcion": "Aserrador - Madera"
      },
      {
        "idOcupacion": 149,
        "descripcion": "Buceo comercial Inland / Onshore - con uso de explosivos"
      },
      {
        "idOcupacion": 708,
        "descripcion": "Meteorologo"
      },
      {
        "idOcupacion": 418,
        "descripcion": "Escolta - Custodio"
      },
      {
        "idOcupacion": 245,
        "descripcion": "Clisador"
      },
      {
        "idOcupacion": 72,
        "descripcion": "Artista de grabacion"
      },
      {
        "idOcupacion": 614,
        "descripcion": "Ingeniero quimico"
      },
      {
        "idOcupacion": 948,
        "descripcion": "Traga espadas"
      },
      {
        "idOcupacion": 411,
        "descripcion": "Entrenador - Equipo deportivo"
      },
      {
        "idOcupacion": 391,
        "descripcion": "Empleado industria carnica"
      },
      {
        "idOcupacion": 617,
        "descripcion": "Inspector tecnico"
      },
      {
        "idOcupacion": 986,
        "descripcion": "Almacenero - Administrativo"
      },
      {
        "idOcupacion": 303,
        "descripcion": "Demoledor con uso de explosivos"
      },
      {
        "idOcupacion": 808,
        "descripcion": "Piloto Aviacion comercial -  de helicoptero"
      },
      {
        "idOcupacion": 193,
        "descripcion": "Cargador/operador de vagoneta - Cantera"
      },
      {
        "idOcupacion": 76,
        "descripcion": "Aserrador - Artesanal"
      },
      {
        "idOcupacion": 806,
        "descripcion": "Piloto aviacion comercial - autogiros"
      },
      {
        "idOcupacion": 176,
        "descripcion": "Campesino"
      },
      {
        "idOcupacion": 357,
        "descripcion": "Economista"
      },
      {
        "idOcupacion": 143,
        "descripcion": "Bombero - Extincion de fuego en tierra"
      },
      {
        "idOcupacion": 389,
        "descripcion": "Empleado industria bioquimica"
      },
      {
        "idOcupacion": 434,
        "descripcion": "Excavador"
      },
      {
        "idOcupacion": 543,
        "descripcion": "Homeopata"
      },
      {
        "idOcupacion": 911,
        "descripcion": "Siderurgia"
      },
      {
        "idOcupacion": 355,
        "descripcion": "Dueño/Propietario de restaurante"
      },
      {
        "idOcupacion": 150,
        "descripcion": "Buceo comercial Inland / Onshore - sin uso de explosivos"
      },
      {
        "idOcupacion": 784,
        "descripcion": "Percusionista"
      },
      {
        "idOcupacion": 753,
        "descripcion": "Oftalmologo"
      },
      {
        "idOcupacion": 857,
        "descripcion": "Programador analista"
      },
      {
        "idOcupacion": 666,
        "descripcion": "Limpiador de vidrios en altura"
      },
      {
        "idOcupacion": 507,
        "descripcion": "Geologo - Mineria tareas bajo tierra"
      },
      {
        "idOcupacion": 93,
        "descripcion": "Aterrajador"
      },
      {
        "idOcupacion": 691,
        "descripcion": "Marina mercante en zona sin riesgo de residencia"
      },
      {
        "idOcupacion": 377,
        "descripcion": "Empleado civil de arsenales, polvorines"
      },
      {
        "idOcupacion": 1103,
        "descripcion": "Piloto Aviacion comercial - vuelo regular (transporte de pasajeros y carga)"
      },
      {
        "idOcupacion": 45,
        "descripcion": "Analista de sistemas"
      },
      {
        "idOcupacion": 897,
        "descripcion": "Rescatista"
      },
      {
        "idOcupacion": 546,
        "descripcion": "Ictiologo"
      },
      {
        "idOcupacion": 1005,
        "descripcion": "Cargador o docker marina mercante en zona sin riesgo"
      },
      {
        "idOcupacion": 354,
        "descripcion": "Dragador"
      },
      {
        "idOcupacion": 902,
        "descripcion": "Sacerdote"
      },
      {
        "idOcupacion": 41,
        "descripcion": "Alguacil"
      },
      {
        "idOcupacion": 1017,
        "descripcion": "Cientifico investigador - Administrativo"
      },
      {
        "idOcupacion": 880,
        "descripcion": "Radiotelegrafista"
      },
      {
        "idOcupacion": 242,
        "descripcion": "Citotaxonomista"
      },
      {
        "idOcupacion": 217,
        "descripcion": "Chofer / Conductor - Autocares"
      },
      {
        "idOcupacion": 637,
        "descripcion": "Instructor - Natacion"
      },
      {
        "idOcupacion": 148,
        "descripcion": "Buceo cientifico y policial - sin uso de explosivos"
      },
      {
        "idOcupacion": 783,
        "descripcion": "Peluquera/Peluquero"
      },
      {
        "idOcupacion": 17,
        "descripcion": "Aerografista"
      },
      {
        "idOcupacion": 792,
        "descripcion": "Persona de compañia"
      },
      {
        "idOcupacion": 985,
        "descripcion": "Almacenero"
      },
      {
        "idOcupacion": 331,
        "descripcion": "Director - Cinematografia/television"
      },
      {
        "idOcupacion": 492,
        "descripcion": "Fundidor"
      },
      {
        "idOcupacion": 871,
        "descripcion": "Publicista - Publicidad aerea"
      },
      {
        "idOcupacion": 580,
        "descripcion": "Ingeniero de estructuras"
      },
      {
        "idOcupacion": 709,
        "descripcion": "Mezclador - TV, cine y radio"
      },
      {
        "idOcupacion": 597,
        "descripcion": "Ingeniero de telecomunicaciones"
      },
      {
        "idOcupacion": 975,
        "descripcion": "Virologo"
      },
      {
        "idOcupacion": 796,
        "descripcion": "Pescador en alta mar"
      },
      {
        "idOcupacion": 1036,
        "descripcion": "Gestión empresarial"
      },
      {
        "idOcupacion": 474,
        "descripcion": "Fuerzas Armadas - Arsenales y artilleros"
      },
      {
        "idOcupacion": 1039,
        "descripcion": "Ingeniero ambiental - Administrativo"
      },
      {
        "idOcupacion": 326,
        "descripcion": "Diplomatico"
      },
      {
        "idOcupacion": 412,
        "descripcion": "Entrenador - Futbol"
      },
      {
        "idOcupacion": 439,
        "descripcion": "Fabricante de asfalto"
      },
      {
        "idOcupacion": 752,
        "descripcion": "Odontologo"
      },
      {
        "idOcupacion": 560,
        "descripcion": "Industria petrolera - Plataforma petrolifera personal directivo y de control"
      },
      {
        "idOcupacion": 569,
        "descripcion": "Ingeniero agricultura"
      },
      {
        "idOcupacion": 655,
        "descripcion": "Juez de paz"
      },
      {
        "idOcupacion": 732,
        "descripcion": "Monitor de natacion"
      },
      {
        "idOcupacion": 790,
        "descripcion": "Periodista en zona sin riesgo"
      },
      {
        "idOcupacion": 307,
        "descripcion": "Desaguador / vaciador de pozo septico"
      },
      {
        "idOcupacion": 515,
        "descripcion": "Grabador"
      },
      {
        "idOcupacion": 503,
        "descripcion": "Genetista"
      },
      {
        "idOcupacion": 247,
        "descripcion": "Cobrador en zonas sin peligros especiales tales como: violencia, delitos, conflictos etnicos, etc"
      },
      {
        "idOcupacion": 427,
        "descripcion": "Esteticista veterinario"
      },
      {
        "idOcupacion": 758,
        "descripcion": "Orfebre"
      },
      {
        "idOcupacion": 133,
        "descripcion": "Bibliotecario"
      },
      {
        "idOcupacion": 6,
        "descripcion": "Actuario"
      },
      {
        "idOcupacion": 157,
        "descripcion": "Buceo profesional - debajo del hielo"
      },
      {
        "idOcupacion": 66,
        "descripcion": "Arquitecto de interiores"
      },
      {
        "idOcupacion": 63,
        "descripcion": "Arponero"
      },
      {
        "idOcupacion": 630,
        "descripcion": "Instructor - Buceo recreativo"
      },
      {
        "idOcupacion": 46,
        "descripcion": "Animador"
      },
      {
        "idOcupacion": 572,
        "descripcion": "Ingeniero comercial"
      },
      {
        "idOcupacion": 1026,
        "descripcion": "Finanzas"
      },
      {
        "idOcupacion": 747,
        "descripcion": "Nutricionista"
      },
      {
        "idOcupacion": 459,
        "descripcion": "Fisioterapeuta"
      },
      {
        "idOcupacion": 50,
        "descripcion": "Antropologo"
      },
      {
        "idOcupacion": 1037,
        "descripcion": "Gestor administrativo"
      },
      {
        "idOcupacion": 829,
        "descripcion": "Policia - Nacional o Federal"
      },
      {
        "idOcupacion": 362,
        "descripcion": "Ejecutivo de cuentas"
      },
      {
        "idOcupacion": 189,
        "descripcion": "Capataz hacienda/fincas"
      },
      {
        "idOcupacion": 227,
        "descripcion": "Cientifico agricola"
      },
      {
        "idOcupacion": 36,
        "descripcion": "Agrostologo"
      },
      {
        "idOcupacion": 999,
        "descripcion": "Asistente veterinario"
      },
      {
        "idOcupacion": 972,
        "descripcion": "Vigilante/Guardia - Sin porta de armas"
      },
      {
        "idOcupacion": 851,
        "descripcion": "Profesor de medicina"
      },
      {
        "idOcupacion": 667,
        "descripcion": "Linguista"
      },
      {
        "idOcupacion": 59,
        "descripcion": "Archivista de administracion local"
      },
      {
        "idOcupacion": 168,
        "descripcion": "Calibrador - Instrumentos de precision"
      },
      {
        "idOcupacion": 960,
        "descripcion": "Tripulacion Aviacion comercial - vuelo regular (transporte de carga y pasajeros)"
      },
      {
        "idOcupacion": 328,
        "descripcion": "Diplomatico en paises o zonas con peligros especiales"
      },
      {
        "idOcupacion": 366,
        "descripcion": "Empacador"
      },
      {
        "idOcupacion": 830,
        "descripcion": "Policia - Provincia o autonomica"
      },
      {
        "idOcupacion": 987,
        "descripcion": "Almacenero / descargador"
      },
      {
        "idOcupacion": 1011,
        "descripcion": "Cientifico botanico Administrativo"
      },
      {
        "idOcupacion": 558,
        "descripcion": "Industria petrolera - Plataforma petrolifera empleados que realizan tareas peligrosas"
      },
      {
        "idOcupacion": 865,
        "descripcion": "Propietario de sanatorio de reposo"
      },
      {
        "idOcupacion": 973,
        "descripcion": "Vinicultor"
      },
      {
        "idOcupacion": 171,
        "descripcion": "Camarero centro nocturno"
      },
      {
        "idOcupacion": 137,
        "descripcion": "Bioquimico de ensayo"
      },
      {
        "idOcupacion": 923,
        "descripcion": "Taquigrafo/a"
      },
      {
        "idOcupacion": 71,
        "descripcion": "Artista de circo"
      },
      {
        "idOcupacion": 685,
        "descripcion": "Manipulador industrial de pinturas"
      },
      {
        "idOcupacion": 698,
        "descripcion": "Mecanico de motores"
      },
      {
        "idOcupacion": 1012,
        "descripcion": "Cientifico de ciencias naturales - Administrativo"
      },
      {
        "idOcupacion": 974,
        "descripcion": "Violonchelista"
      },
      {
        "idOcupacion": 1112,
        "descripcion": "Supervisor de almacenes - Campo"
      },
      {
        "idOcupacion": 885,
        "descripcion": "Rector"
      },
      {
        "idOcupacion": 20,
        "descripcion": "Afinador de pianos"
      },
      {
        "idOcupacion": 416,
        "descripcion": "Entrenador individual deportivo profesional"
      },
      {
        "idOcupacion": 690,
        "descripcion": "Marina mercante en zona de riesgo"
      },
      {
        "idOcupacion": 400,
        "descripcion": "Encuestador - trabajo de campo"
      },
      {
        "idOcupacion": 457,
        "descripcion": "Fisico nuclear"
      },
      {
        "idOcupacion": 372,
        "descripcion": "Empleado administrativo"
      },
      {
        "idOcupacion": 319,
        "descripcion": "Detonador - Detonaciones"
      },
      {
        "idOcupacion": 19,
        "descripcion": "Afinador de organos"
      },
      {
        "idOcupacion": 721,
        "descripcion": "Minero - Tareas bajo tierra"
      },
      {
        "idOcupacion": 446,
        "descripcion": "Fabricante de prendas de vestir"
      },
      {
        "idOcupacion": 859,
        "descripcion": "Programador informatico"
      },
      {
        "idOcupacion": 207,
        "descripcion": "Ceramista"
      },
      {
        "idOcupacion": 213,
        "descripcion": "Chatarrero - Metal"
      },
      {
        "idOcupacion": 1074,
        "descripcion": "Juez - Administrativo"
      },
      {
        "idOcupacion": 1030,
        "descripcion": "Futbolista profesional"
      },
      {
        "idOcupacion": 852,
        "descripcion": "Profesor de natacion"
      },
      {
        "idOcupacion": 800,
        "descripcion": "Picapedrero"
      },
      {
        "idOcupacion": 969,
        "descripcion": "Vicario"
      },
      {
        "idOcupacion": 320,
        "descripcion": "Diaconisa"
      },
      {
        "idOcupacion": 223,
        "descripcion": "Chofer / Conductorde reparto/carga y descarga en furgoneta, camion o coche"
      },
      {
        "idOcupacion": 965,
        "descripcion": "Vendedor en zona de conflicto"
      },
      {
        "idOcupacion": 854,
        "descripcion": "Profesor escuela de conducir"
      },
      {
        "idOcupacion": 990,
        "descripcion": "Analista financiero"
      },
      {
        "idOcupacion": 944,
        "descripcion": "Trabajador de circo"
      },
      {
        "idOcupacion": 864,
        "descripcion": "Propietario de residencia de tercera edad"
      },
      {
        "idOcupacion": 500,
        "descripcion": "Gasista - supervisor"
      },
      {
        "idOcupacion": 759,
        "descripcion": "Orfebre piedras preciosas y metales"
      },
      {
        "idOcupacion": 469,
        "descripcion": "Fraile"
      },
      {
        "idOcupacion": 749,
        "descripcion": "Obrero altos hornos / siderurgica"
      },
      {
        "idOcupacion": 1106,
        "descripcion": "Quimico Farmaceutico"
      },
      {
        "idOcupacion": 141,
        "descripcion": "Bombero - Extincion de fuego bajo tierra"
      },
      {
        "idOcupacion": 204,
        "descripcion": "Cementista"
      },
      {
        "idOcupacion": 1098,
        "descripcion": "Operario - Administrador"
      },
      {
        "idOcupacion": 951,
        "descripcion": "Trampoline - Competicion"
      },
      {
        "idOcupacion": 687,
        "descripcion": "Maquillador"
      },
      {
        "idOcupacion": 804,
        "descripcion": "Piloto Aviacion comercial - aerofotografos, aerotaxis"
      },
      {
        "idOcupacion": 913,
        "descripcion": "Sociologo"
      },
      {
        "idOcupacion": 967,
        "descripcion": "Venereologo"
      },
      {
        "idOcupacion": 214,
        "descripcion": "Chatarrero ambulante"
      },
      {
        "idOcupacion": 73,
        "descripcion": "Artista profesional"
      },
      {
        "idOcupacion": 834,
        "descripcion": "Politico paises no democraticos"
      },
      {
        "idOcupacion": 943,
        "descripcion": "Trabajador de boleteria en circo"
      },
      {
        "idOcupacion": 528,
        "descripcion": "Guia"
      },
      {
        "idOcupacion": 262,
        "descripcion": "Conductor metro"
      },
      {
        "idOcupacion": 250,
        "descripcion": "Colocador de vidrios en altura"
      },
      {
        "idOcupacion": 681,
        "descripcion": "Manipulador de fuegos artificiales"
      },
      {
        "idOcupacion": 719,
        "descripcion": "Minero - administrativo / campamento"
      },
      {
        "idOcupacion": 788,
        "descripcion": "Perfusionista"
      },
      {
        "idOcupacion": 1102,
        "descripcion": "Piloto aviacion comercial - escuela de aviacion"
      },
      {
        "idOcupacion": 574,
        "descripcion": "Ingeniero consultor de construccion de edificios"
      },
      {
        "idOcupacion": 188,
        "descripcion": "Capataz de trabajadores portuarios"
      },
      {
        "idOcupacion": 705,
        "descripcion": "Mesero"
      },
      {
        "idOcupacion": 688,
        "descripcion": "Maquinista de ferrocarril"
      },
      {
        "idOcupacion": 293,
        "descripcion": "Critico cinematografico"
      },
      {
        "idOcupacion": 365,
        "descripcion": "Embriologo"
      },
      {
        "idOcupacion": 325,
        "descripcion": "Dinamitero - Dinamita"
      },
      {
        "idOcupacion": 236,
        "descripcion": "Cientifico investigador"
      },
      {
        "idOcupacion": 529,
        "descripcion": "Guia caminos del Inca"
      },
      {
        "idOcupacion": 916,
        "descripcion": "Soldador"
      },
      {
        "idOcupacion": 961,
        "descripcion": "Tripulacion Aviacion comercial vuelo no regular (transporte de carga y pasajeros)"
      },
      {
        "idOcupacion": 470,
        "descripcion": "Frenista"
      },
      {
        "idOcupacion": 728,
        "descripcion": "Modelo de industria de la moda y entretenimiento"
      },
      {
        "idOcupacion": 849,
        "descripcion": "Profesor de gimnasia de rehabilitacion"
      },
      {
        "idOcupacion": 968,
        "descripcion": "Veterinario"
      },
      {
        "idOcupacion": 1044,
        "descripcion": "Ingeniero de refrigeracion - Administrativo"
      },
      {
        "idOcupacion": 552,
        "descripcion": "Industria carnica"
      },
      {
        "idOcupacion": 102,
        "descripcion": "Auxiliar de odontologia"
      },
      {
        "idOcupacion": 464,
        "descripcion": "Forense"
      },
      {
        "idOcupacion": 103,
        "descripcion": "Auxiliar de vuelo / aeromozo o aeromoza - Vuelo no regular"
      },
      {
        "idOcupacion": 370,
        "descripcion": "Empleada/empleado servicio domestico"
      },
      {
        "idOcupacion": 715,
        "descripcion": "Microbiologo"
      },
      {
        "idOcupacion": 1062,
        "descripcion": "Ingeniero mecanico Administrativo"
      },
      {
        "idOcupacion": 279,
        "descripcion": "Corredor - Finanzas"
      },
      {
        "idOcupacion": 706,
        "descripcion": "Mesero centro nocturno"
      },
      {
        "idOcupacion": 413,
        "descripcion": "Entrenador de fitness"
      },
      {
        "idOcupacion": 589,
        "descripcion": "Ingeniero de planeacion"
      },
      {
        "idOcupacion": 640,
        "descripcion": "Instructor - Techno gym"
      },
      {
        "idOcupacion": 980,
        "descripcion": "Zurcidor"
      },
      {
        "idOcupacion": 686,
        "descripcion": "Maquetador"
      },
      {
        "idOcupacion": 725,
        "descripcion": "Misionera/Misionero en paises no peligrosos"
      },
      {
        "idOcupacion": 106,
        "descripcion": "Auxiliar medico"
      },
      {
        "idOcupacion": 627,
        "descripcion": "Instructor - Artes marciales sin contacto"
      },
      {
        "idOcupacion": 754,
        "descripcion": "Operador de maquinas de obra y movimiento de tierra"
      },
      {
        "idOcupacion": 177,
        "descripcion": "Cantante"
      },
      {
        "idOcupacion": 88,
        "descripcion": "Asistente"
      },
      {
        "idOcupacion": 192,
        "descripcion": "Cardenal"
      },
      {
        "idOcupacion": 450,
        "descripcion": "Farmaceutico"
      },
      {
        "idOcupacion": 579,
        "descripcion": "Ingeniero de drenaje"
      },
      {
        "idOcupacion": 502,
        "descripcion": "Genealogista"
      },
      {
        "idOcupacion": 1043,
        "descripcion": "Ingeniero de radio - Administrativo"
      },
      {
        "idOcupacion": 281,
        "descripcion": "Corredor de bolsa"
      },
      {
        "idOcupacion": 811,
        "descripcion": "Piloto aviacion comercial - Publicidad aerea"
      },
      {
        "idOcupacion": 893,
        "descripcion": "Repartidor en auto, furgoneta o camion"
      },
      {
        "idOcupacion": 935,
        "descripcion": "Terapeuta"
      },
      {
        "idOcupacion": 945,
        "descripcion": "Trabajador de lavanderia"
      },
      {
        "idOcupacion": 218,
        "descripcion": "Chofer / Conductor - Taxis"
      },
      {
        "idOcupacion": 763,
        "descripcion": "Osteopata"
      },
      {
        "idOcupacion": 348,
        "descripcion": "Diseñador grafico"
      },
      {
        "idOcupacion": 598,
        "descripcion": "Ingeniero de television"
      },
      {
        "idOcupacion": 1054,
        "descripcion": "Ingeniero de video - Administrativo"
      },
      {
        "idOcupacion": 125,
        "descripcion": "Bailarin/a de ballet"
      },
      {
        "idOcupacion": 78,
        "descripcion": "Aserrador - Corcho"
      },
      {
        "idOcupacion": 539,
        "descripcion": "Hidrografo"
      },
      {
        "idOcupacion": 257,
        "descripcion": "Concejal - Paises no democraticos"
      },
      {
        "idOcupacion": 556,
        "descripcion": "Industria petrolera - Busqueda, exploracion o explotacion de pozos"
      },
      {
        "idOcupacion": 955,
        "descripcion": "Transporte de valores o caudales"
      },
      {
        "idOcupacion": 997,
        "descripcion": "Asistente administrativo"
      },
      {
        "idOcupacion": 770,
        "descripcion": "Pantografo"
      },
      {
        "idOcupacion": 318,
        "descripcion": "Detective privado - sin armas"
      },
      {
        "idOcupacion": 350,
        "descripcion": "Diseñador/diseñadora de modas"
      },
      {
        "idOcupacion": 1006,
        "descripcion": "Catering"
      },
      {
        "idOcupacion": 892,
        "descripcion": "Reparador tecnico"
      },
      {
        "idOcupacion": 451,
        "descripcion": "Farmaceutico - Laboratorio"
      },
      {
        "idOcupacion": 926,
        "descripcion": "Taxonomo"
      },
      {
        "idOcupacion": 958,
        "descripcion": "Tratante de gemas"
      },
      {
        "idOcupacion": 275,
        "descripcion": "Copiador - Imprenta"
      },
      {
        "idOcupacion": 970,
        "descripcion": "Vicecanciller"
      },
      {
        "idOcupacion": 282,
        "descripcion": "Corredor de propiedades"
      },
      {
        "idOcupacion": 632,
        "descripcion": "Instructor - educacion"
      },
      {
        "idOcupacion": 1114,
        "descripcion": "Supervisor de mantenimiento"
      },
      {
        "idOcupacion": 305,
        "descripcion": "Dentista"
      },
      {
        "idOcupacion": 175,
        "descripcion": "Cambista"
      },
      {
        "idOcupacion": 61,
        "descripcion": "Aromaterapeuta"
      },
      {
        "idOcupacion": 158,
        "descripcion": "Buceo profesional - intentos de batir record de profundidad"
      },
      {
        "idOcupacion": 510,
        "descripcion": "Geomorfologo"
      },
      {
        "idOcupacion": 693,
        "descripcion": "Matematico"
      },
      {
        "idOcupacion": 1066,
        "descripcion": "Ingeniero quimico Administrativo"
      },
      {
        "idOcupacion": 605,
        "descripcion": "Ingeniero en informatica"
      },
      {
        "idOcupacion": 581,
        "descripcion": "Ingeniero de grabacion"
      },
      {
        "idOcupacion": 408,
        "descripcion": "Ensayador - Metales"
      },
      {
        "idOcupacion": 453,
        "descripcion": "Financiero"
      },
      {
        "idOcupacion": 174,
        "descripcion": "Camarografo sin riesgo de zona de conflicto"
      },
      {
        "idOcupacion": 134,
        "descripcion": "Biofisico"
      },
      {
        "idOcupacion": 840,
        "descripcion": "Procurador"
      },
      {
        "idOcupacion": 858,
        "descripcion": "Programador de TI"
      },
      {
        "idOcupacion": 490,
        "descripcion": "Funcionario/director ejecutivo - Administracion publica"
      },
      {
        "idOcupacion": 653,
        "descripcion": "Jornalero"
      },
      {
        "idOcupacion": 797,
        "descripcion": "Pescador en costas, rios y lagos"
      },
      {
        "idOcupacion": 979,
        "descripcion": "Zoologo"
      },
      {
        "idOcupacion": 740,
        "descripcion": "Mozo de espada/Estoque - Toros"
      },
      {
        "idOcupacion": 789,
        "descripcion": "Periodista en zona de conflicto"
      },
      {
        "idOcupacion": 901,
        "descripcion": "Rimac"
      },
      {
        "idOcupacion": 33,
        "descripcion": "Agricultor"
      },
      {
        "idOcupacion": 422,
        "descripcion": "Estadistico"
      },
      {
        "idOcupacion": 1081,
        "descripcion": "Marina mercante  tripulante en zona sin riesgo"
      },
      {
        "idOcupacion": 443,
        "descripcion": "Fabricante de fuegos artificiales"
      },
      {
        "idOcupacion": 577,
        "descripcion": "Ingeniero de buses - ensamblaje y mantenimiento"
      },
      {
        "idOcupacion": 532,
        "descripcion": "Guitarrista"
      },
      {
        "idOcupacion": 222,
        "descripcion": "Chofer / Conductor vehiculo de transporte de valores o caudales"
      },
      {
        "idOcupacion": 466,
        "descripcion": "Fotografo en zona de conflicto"
      },
      {
        "idOcupacion": 826,
        "descripcion": "Policia - Carcelero, guardia de carcel"
      },
      {
        "idOcupacion": 841,
        "descripcion": "Productor de television"
      },
      {
        "idOcupacion": 682,
        "descripcion": "Manipulador de residuos hospitalarios"
      },
      {
        "idOcupacion": 936,
        "descripcion": "Termodinamicista"
      },
      {
        "idOcupacion": 613,
        "descripcion": "Ingeniero produccion de armas"
      },
      {
        "idOcupacion": 922,
        "descripcion": "Tapicero"
      },
      {
        "idOcupacion": 458,
        "descripcion": "Fisiologo"
      },
      {
        "idOcupacion": 34,
        "descripcion": "Agrimensor"
      },
      {
        "idOcupacion": 1083,
        "descripcion": "Masajista"
      },
      {
        "idOcupacion": 35,
        "descripcion": "Agronomo"
      },
      {
        "idOcupacion": 114,
        "descripcion": "Aviador militar - alumno"
      },
      {
        "idOcupacion": 1031,
        "descripcion": "Ganadero -Administrativo"
      },
      {
        "idOcupacion": 479,
        "descripcion": "Fuerzas Armadas - Dragaminas"
      },
      {
        "idOcupacion": 521,
        "descripcion": "Grifero / Expendedor de combustibles (gasolina, gas, queroseno, otros)"
      },
      {
        "idOcupacion": 42,
        "descripcion": "Ama de casa"
      },
      {
        "idOcupacion": 167,
        "descripcion": "Calentador de remaches - Astilleros, reparacion de buques e ingenieria naval"
      },
      {
        "idOcupacion": 1115,
        "descripcion": "Supervisor Mozo"
      },
      {
        "idOcupacion": 998,
        "descripcion": "Asistente campo"
      },
      {
        "idOcupacion": 1,
        "descripcion": "Abogado"
      },
      {
        "idOcupacion": 769,
        "descripcion": "Panadero"
      },
      {
        "idOcupacion": 658,
        "descripcion": "Lanzacuchillos"
      },
      {
        "idOcupacion": 545,
        "descripcion": "Hornero altos hornos"
      },
      {
        "idOcupacion": 966,
        "descripcion": "Vendedor en zona sin conflicto"
      },
      {
        "idOcupacion": 272,
        "descripcion": "Contratista"
      },
      {
        "idOcupacion": 925,
        "descripcion": "Tasador - Ganado"
      },
      {
        "idOcupacion": 836,
        "descripcion": "Preparador de tragos"
      },
      {
        "idOcupacion": 77,
        "descripcion": "Aserrador - Canteria"
      },
      {
        "idOcupacion": 436,
        "descripcion": "Explorador submarino - comercial, cientifico o militar"
      },
      {
        "idOcupacion": 669,
        "descripcion": "Litografo"
      },
      {
        "idOcupacion": 49,
        "descripcion": "Anticuario"
      },
      {
        "idOcupacion": 816,
        "descripcion": "Pintor de edificio y casa en altura"
      },
      {
        "idOcupacion": 929,
        "descripcion": "Tecnico de giras artisticas"
      },
      {
        "idOcupacion": 392,
        "descripcion": "Empleado industria farmaceutica"
      },
      {
        "idOcupacion": 618,
        "descripcion": "Instalador de antenas"
      },
      {
        "idOcupacion": 1016,
        "descripcion": "Cientifico hortofruticola - Administrativo"
      },
      {
        "idOcupacion": 105,
        "descripcion": "Auxiliar farmacia"
      },
      {
        "idOcupacion": 585,
        "descripcion": "Ingeniero de minas - Manejo de explosivos"
      },
      {
        "idOcupacion": 353,
        "descripcion": "Domador de fieras - Circo"
      },
      {
        "idOcupacion": 37,
        "descripcion": "Albañil construccion"
      },
      {
        "idOcupacion": 147,
        "descripcion": "Buceo cientifico y policial - con uso de explosivos"
      },
      {
        "idOcupacion": 1040,
        "descripcion": "Ingeniero ambiental - Campo"
      },
      {
        "idOcupacion": 716,
        "descripcion": "Microfilmador"
      },
      {
        "idOcupacion": 748,
        "descripcion": "Obrero"
      },
      {
        "idOcupacion": 121,
        "descripcion": "Aviador militar - tripulacion, pasajeros de helicoptero"
      },
      {
        "idOcupacion": 234,
        "descripcion": "Cientifico de laboratorio medico"
      },
      {
        "idOcupacion": 196,
        "descripcion": "Carpintero en construccion"
      },
      {
        "idOcupacion": 744,
        "descripcion": "Musico de sinfonica"
      },
      {
        "idOcupacion": 1084,
        "descripcion": "Mecanico Aeronautico"
      },
      {
        "idOcupacion": 862,
        "descripcion": "Propietario centro nocturno (Discoteca/Pub)"
      },
      {
        "idOcupacion": 660,
        "descripcion": "Leñador"
      },
      {
        "idOcupacion": 745,
        "descripcion": "Naturopata"
      },
      {
        "idOcupacion": 438,
        "descripcion": "Fabricante de armas"
      },
      {
        "idOcupacion": 548,
        "descripcion": "Importador/Exportador"
      },
      {
        "idOcupacion": 429,
        "descripcion": "Estilista"
      },
      {
        "idOcupacion": 820,
        "descripcion": "Plomero / Gasfitero"
      },
      {
        "idOcupacion": 563,
        "descripcion": "Industria quimica - Empleados que utilizan sustancias no peligrosas"
      },
      {
        "idOcupacion": 931,
        "descripcion": "Tecnico en instalacion/montaje de ascensores"
      },
      {
        "idOcupacion": 409,
        "descripcion": "Entomologo"
      },
      {
        "idOcupacion": 349,
        "descripcion": "Diseñador textil"
      },
      {
        "idOcupacion": 498,
        "descripcion": "Ganadero - Utilizacion maquinaria pesada"
      },
      {
        "idOcupacion": 703,
        "descripcion": "Mensajero de reparto / carga y descarga en moto"
      },
      {
        "idOcupacion": 772,
        "descripcion": "Parasitologo"
      },
      {
        "idOcupacion": 733,
        "descripcion": "Monitor de tenis"
      },
      {
        "idOcupacion": 909,
        "descripcion": "Servicios de seguridad - Portador de armas"
      },
      {
        "idOcupacion": 522,
        "descripcion": "Gruista"
      },
      {
        "idOcupacion": 917,
        "descripcion": "Sommelier"
      },
      {
        "idOcupacion": 596,
        "descripcion": "Ingeniero de suelos"
      },
      {
        "idOcupacion": 827,
        "descripcion": "Policia - Desactivacion de explosivos"
      },
      {
        "idOcupacion": 92,
        "descripcion": "Astronomo"
      },
      {
        "idOcupacion": 405,
        "descripcion": "Engastador"
      },
      {
        "idOcupacion": 899,
        "descripcion": "Reumatologo"
      },
      {
        "idOcupacion": 101,
        "descripcion": "Auxiliar de enfermeria"
      },
      {
        "idOcupacion": 51,
        "descripcion": "Aparejador"
      },
      {
        "idOcupacion": 109,
        "descripcion": "Aviacion comercial - Extinguidor de incendios"
      },
      {
        "idOcupacion": 1094,
        "descripcion": "Musico - Administrativo"
      },
      {
        "idOcupacion": 216,
        "descripcion": "Chofer / Conductor - Ambulancia"
      },
      {
        "idOcupacion": 112,
        "descripcion": "Aviacion comercial - Rescatista"
      },
      {
        "idOcupacion": 976,
        "descripcion": "Visitador medico"
      },
      {
        "idOcupacion": 746,
        "descripcion": "Notario"
      },
      {
        "idOcupacion": 144,
        "descripcion": "Bombero - Proteccion o defensa civil"
      },
      {
        "idOcupacion": 591,
        "descripcion": "Ingeniero de produccion"
      },
      {
        "idOcupacion": 64,
        "descripcion": "Arqueologo"
      },
      {
        "idOcupacion": 87,
        "descripcion": "Asfaltador - Sector de la construccion"
      },
      {
        "idOcupacion": 1004,
        "descripcion": "Botanico - Administrativo"
      },
      {
        "idOcupacion": 1042,
        "descripcion": "Ingeniero de produccion - Administrativo"
      },
      {
        "idOcupacion": 441,
        "descripcion": "Fabricante de cemento"
      },
      {
        "idOcupacion": 43,
        "descripcion": "Analista de asistencia tecnica - Informatica"
      },
      {
        "idOcupacion": 1045,
        "descripcion": "Ingeniero de sanamiento"
      },
      {
        "idOcupacion": 146,
        "descripcion": "Brigadista antiterrorista"
      },
      {
        "idOcupacion": 1071,
        "descripcion": "Jefe de Ingenieria- Administrativo"
      },
      {
        "idOcupacion": 837,
        "descripcion": "Presentador/ presentadora de espectaculos"
      },
      {
        "idOcupacion": 456,
        "descripcion": "Fisico - Quimico - Bioquimico"
      },
      {
        "idOcupacion": 337,
        "descripcion": "Director artistico"
      },
      {
        "idOcupacion": 1033,
        "descripcion": "Gasista - inspector"
      },
      {
        "idOcupacion": 723,
        "descripcion": "Minero -Trabajador de mina"
      },
      {
        "idOcupacion": 778,
        "descripcion": "Patologo"
      },
      {
        "idOcupacion": 1109,
        "descripcion": "Supervisor Administrativo"
      },
      {
        "idOcupacion": 5,
        "descripcion": "Actriz"
      },
      {
        "idOcupacion": 525,
        "descripcion": "Guardacostas - Trabajo en oficina"
      },
      {
        "idOcupacion": 1052,
        "descripcion": "Ingeniero de ventas - Administrativo"
      },
      {
        "idOcupacion": 313,
        "descripcion": "Desminador explosivos"
      },
      {
        "idOcupacion": 952,
        "descripcion": "Transporte de mercancias no peligrosas"
      },
      {
        "idOcupacion": 481,
        "descripcion": "Fuerzas Armadas - Salvamento"
      },
      {
        "idOcupacion": 616,
        "descripcion": "Inspector de sanidad publica"
      },
      {
        "idOcupacion": 310,
        "descripcion": "Desguazador de buques"
      },
      {
        "idOcupacion": 237,
        "descripcion": "Cientifico medico"
      },
      {
        "idOcupacion": 22,
        "descripcion": "Agente artistico"
      },
      {
        "idOcupacion": 284,
        "descripcion": "Corredor de Seguros - Asesor financiero independiente"
      },
      {
        "idOcupacion": 814,
        "descripcion": "Piloto de prueba - Aviacion comercial"
      },
      {
        "idOcupacion": 659,
        "descripcion": "Laringologo"
      },
      {
        "idOcupacion": 367,
        "descripcion": "Empacador - cemento"
      },
      {
        "idOcupacion": 336,
        "descripcion": "Director - Teatro"
      },
      {
        "idOcupacion": 819,
        "descripcion": "Plisador"
      },
      {
        "idOcupacion": 335,
        "descripcion": "Director - Personal"
      },
      {
        "idOcupacion": 765,
        "descripcion": "Otorrinolaringologo"
      },
      {
        "idOcupacion": 895,
        "descripcion": "Repostero"
      },
      {
        "idOcupacion": 1111,
        "descripcion": "Supervisor de almacenes - Administrativo"
      },
      {
        "idOcupacion": 791,
        "descripcion": "Perito"
      },
      {
        "idOcupacion": 107,
        "descripcion": "Aviacion civil o comercial - Instructor de vuelo"
      },
      {
        "idOcupacion": 553,
        "descripcion": "Industria energetica"
      },
      {
        "idOcupacion": 863,
        "descripcion": "Propietario de bar, cantina o pub (excepto centros nocturnos)"
      },
      {
        "idOcupacion": 473,
        "descripcion": "Fuerzas Armadas - Actividades militares basicas (tierra, mar y aire)"
      },
      {
        "idOcupacion": 334,
        "descripcion": "Director - Musical"
      },
      {
        "idOcupacion": 68,
        "descripcion": "Artesano"
      },
      {
        "idOcupacion": 919,
        "descripcion": "Supervisor de obras"
      },
      {
        "idOcupacion": 1003,
        "descripcion": "Biologo - Administrativo"
      },
      {
        "idOcupacion": 1048,
        "descripcion": "Ingeniero de software - Administrativo"
      },
      {
        "idOcupacion": 771,
        "descripcion": "Paramedico"
      },
      {
        "idOcupacion": 258,
        "descripcion": "Conductor - Repartidor de pedidos"
      },
      {
        "idOcupacion": 243,
        "descripcion": "Clasificador de residuos patologicos"
      },
      {
        "idOcupacion": 636,
        "descripcion": "Instructor - Gimnasio"
      },
      {
        "idOcupacion": 689,
        "descripcion": "Marchante de arte"
      },
      {
        "idOcupacion": 449,
        "descripcion": "Fabricante productos de hule"
      },
      {
        "idOcupacion": 90,
        "descripcion": "Astillero"
      },
      {
        "idOcupacion": 564,
        "descripcion": "Industria quimica - Empleados que utilizan sustancias peligrosas"
      },
      {
        "idOcupacion": 984,
        "descripcion": "Agronomo - Administrativo"
      },
      {
        "idOcupacion": 737,
        "descripcion": "Montador sector audiovisual"
      },
      {
        "idOcupacion": 1067,
        "descripcion": "Ingeniero Sanitario - Administrartivo"
      },
      {
        "idOcupacion": 1024,
        "descripcion": "Eventos deportivos, musicales y sociales"
      },
      {
        "idOcupacion": 739,
        "descripcion": "Montaje de grua"
      },
      {
        "idOcupacion": 839,
        "descripcion": "Prior"
      },
      {
        "idOcupacion": 1117,
        "descripcion": "Tecnologo"
      },
      {
        "idOcupacion": 540,
        "descripcion": "Higienista ocupacional"
      },
      {
        "idOcupacion": 894,
        "descripcion": "Repartidor en moto - Motoboy, servicios de mensajeria, entrega a domicilio"
      },
      {
        "idOcupacion": 524,
        "descripcion": "Guardacostas"
      },
      {
        "idOcupacion": 29,
        "descripcion": "Agente de viajes"
      },
      {
        "idOcupacion": 24,
        "descripcion": "Agente de bolsa"
      },
      {
        "idOcupacion": 847,
        "descripcion": "Profesor de ballet"
      },
      {
        "idOcupacion": 873,
        "descripcion": "Pulidor de gemas"
      },
      {
        "idOcupacion": 1104,
        "descripcion": "Policia - Artificiero de explosivos"
      },
      {
        "idOcupacion": 83,
        "descripcion": "Asesor fiscal"
      },
      {
        "idOcupacion": 1020,
        "descripcion": "Coordinador de eventos sociales, deportivos y musicales"
      },
      {
        "idOcupacion": 1027,
        "descripcion": "Fiscal del poder Judicial - Administrativo"
      },
      {
        "idOcupacion": 23,
        "descripcion": "Agente comisionista"
      },
      {
        "idOcupacion": 432,
        "descripcion": "Etnologo"
      },
      {
        "idOcupacion": 378,
        "descripcion": "Empleado compañia de reaseguro"
      },
      {
        "idOcupacion": 30,
        "descripcion": "Agente editorial"
      },
      {
        "idOcupacion": 1057,
        "descripcion": "Ingeniero en computacion - Administrativo"
      },
      {
        "idOcupacion": 757,
        "descripcion": "Optometrista"
      },
      {
        "idOcupacion": 15,
        "descripcion": "Administrador medico"
      },
      {
        "idOcupacion": 316,
        "descripcion": "Destilador"
      },
      {
        "idOcupacion": 126,
        "descripcion": "Banderillero - Toros"
      },
      {
        "idOcupacion": 776,
        "descripcion": "Pasajero Aviacion comercial - Dirigibles"
      },
      {
        "idOcupacion": 299,
        "descripcion": "Dactilografo"
      },
      {
        "idOcupacion": 424,
        "descripcion": "Estenotipista"
      },
      {
        "idOcupacion": 679,
        "descripcion": "Manipulador de armas de fuego"
      },
      {
        "idOcupacion": 550,
        "descripcion": "Incubacionista de empresas"
      },
      {
        "idOcupacion": 755,
        "descripcion": "Operador electrico"
      },
      {
        "idOcupacion": 701,
        "descripcion": "Medico medicina alternativa"
      },
      {
        "idOcupacion": 356,
        "descripcion": "Ebanista"
      },
      {
        "idOcupacion": 1086,
        "descripcion": "Mecanico de autos - Administrativo"
      },
      {
        "idOcupacion": 680,
        "descripcion": "Manipulador de explosivos"
      },
      {
        "idOcupacion": 1097,
        "descripcion": "Obrero de Mineria - Tareas en superficie"
      },
      {
        "idOcupacion": 368,
        "descripcion": "Empacador tienda/supermercado"
      },
      {
        "idOcupacion": 396,
        "descripcion": "Empresario"
      },
      {
        "idOcupacion": 426,
        "descripcion": "Esteticista canino"
      },
      {
        "idOcupacion": 884,
        "descripcion": "Recolector de fruta con maquina"
      },
      {
        "idOcupacion": 551,
        "descripcion": "Industria automovilistica"
      },
      {
        "idOcupacion": 116,
        "descripcion": "Aviador militar - Bombarderos y aviones de transporte"
      },
      {
        "idOcupacion": 445,
        "descripcion": "Fabricante de juegos pirotecnicos"
      },
      {
        "idOcupacion": 28,
        "descripcion": "Agente de ventas"
      },
      {
        "idOcupacion": 1090,
        "descripcion": "Militar - Artificiero de explosivos"
      },
      {
        "idOcupacion": 497,
        "descripcion": "Ganadero - Ganado manso"
      },
      {
        "idOcupacion": 665,
        "descripcion": "Limpiador de pozos septicos"
      },
      {
        "idOcupacion": 824,
        "descripcion": "Policia - Brigada antiterrorista"
      },
      {
        "idOcupacion": 444,
        "descripcion": "Fabricante de insecticidas"
      },
      {
        "idOcupacion": 1087,
        "descripcion": "Mecanico en barco marina mercante en zona sin riesgo"
      },
      {
        "idOcupacion": 537,
        "descripcion": "Herrero"
      },
      {
        "idOcupacion": 290,
        "descripcion": "Criador de fieras"
      },
      {
        "idOcupacion": 364,
        "descripcion": "Electricista - Tendidos electricos sin y con baja tension"
      },
      {
        "idOcupacion": 159,
        "descripcion": "Buzo - Buceador"
      },
      {
        "idOcupacion": 67,
        "descripcion": "Arquitecto de obras"
      },
      {
        "idOcupacion": 818,
        "descripcion": "Platero"
      },
      {
        "idOcupacion": 11,
        "descripcion": "Adiestrador perros de combate"
      },
      {
        "idOcupacion": 544,
        "descripcion": "Hormigonero / Elaboracion concreto u hormigon"
      },
      {
        "idOcupacion": 910,
        "descripcion": "Servicios de seguridad - sin portar armas"
      },
      {
        "idOcupacion": 358,
        "descripcion": "Ecualizador de sonido"
      },
      {
        "idOcupacion": 431,
        "descripcion": "Etimologo"
      },
      {
        "idOcupacion": 269,
        "descripcion": "Consultor - Direccion de empresa"
      },
      {
        "idOcupacion": 91,
        "descripcion": "Astrofisico"
      },
      {
        "idOcupacion": 1046,
        "descripcion": "Ingeniero de sanamiento - Administrativo"
      },
      {
        "idOcupacion": 1075,
        "descripcion": "Juez de paz - Administrativo"
      },
      {
        "idOcupacion": 775,
        "descripcion": "Pasajero aviacion comercial - cartografia aerea"
      },
      {
        "idOcupacion": 371,
        "descripcion": "Empleado - encargado de mantenimiento / limpieza"
      },
      {
        "idOcupacion": 883,
        "descripcion": "Recepcionista telefonista"
      },
      {
        "idOcupacion": 996,
        "descripcion": "Asfaltador de Obras"
      },
      {
        "idOcupacion": 374,
        "descripcion": "Empleado bancario - Tareas administrativas y gerenciales"
      },
      {
        "idOcupacion": 508,
        "descripcion": "Geologo - Mineria tareas en superficie"
      },
      {
        "idOcupacion": 180,
        "descripcion": "Cantante de rock"
      },
      {
        "idOcupacion": 235,
        "descripcion": "Cientifico hortofruticola"
      },
      {
        "idOcupacion": 84,
        "descripcion": "Asesor juridico"
      },
      {
        "idOcupacion": 942,
        "descripcion": "Trabajador con armas de fuego"
      },
      {
        "idOcupacion": 179,
        "descripcion": "Cantante de opera"
      },
      {
        "idOcupacion": 751,
        "descripcion": "Oceanografo"
      },
      {
        "idOcupacion": 94,
        "descripcion": "Atrezzista"
      },
      {
        "idOcupacion": 1060,
        "descripcion": "Ingeniero Industrial - Administrativo"
      },
      {
        "idOcupacion": 182,
        "descripcion": "Cantero / Pedrero"
      },
      {
        "idOcupacion": 402,
        "descripcion": "Enfermera (con exposicion a sustancias radioactivas)"
      },
      {
        "idOcupacion": 652,
        "descripcion": "Jefe - Estacion de ferrocarril"
      },
      {
        "idOcupacion": 992,
        "descripcion": "Apicultor - Campo"
      },
      {
        "idOcupacion": 673,
        "descripcion": "Magistrado"
      },
      {
        "idOcupacion": 1019,
        "descripcion": "Cientifico meteorologo - Administrativo"
      },
      {
        "idOcupacion": 879,
        "descripcion": "Radiologo"
      },
      {
        "idOcupacion": 536,
        "descripcion": "Herborista de hierbas medicinales"
      },
      {
        "idOcupacion": 906,
        "descripcion": "Salvavidas piscina"
      },
      {
        "idOcupacion": 938,
        "descripcion": "Tipografo"
      },
      {
        "idOcupacion": 828,
        "descripcion": "Policia - Municipal administrativo"
      },
      {
        "idOcupacion": 475,
        "descripcion": "Fuerzas Armadas - Artificiero de explosivos"
      },
      {
        "idOcupacion": 575,
        "descripcion": "Ingeniero de audio"
      },
      {
        "idOcupacion": 140,
        "descripcion": "Bioquimico investigador"
      },
      {
        "idOcupacion": 249,
        "descripcion": "Colocador de lineas telefonicas en altura"
      },
      {
        "idOcupacion": 397,
        "descripcion": "Emsamblador estructuras metalicas"
      },
      {
        "idOcupacion": 57,
        "descripcion": "Arboricultor"
      },
      {
        "idOcupacion": 662,
        "descripcion": "Lexicografo"
      },
      {
        "idOcupacion": 1078,
        "descripcion": "Marina mercante  cargador o docker en zona sin riesgo"
      },
      {
        "idOcupacion": 704,
        "descripcion": "Mensajero de reparto/carga y descarga en furgoneta, camion o coche"
      },
      {
        "idOcupacion": 1028,
        "descripcion": "Fiscal del poder judicial - Campo"
      },
      {
        "idOcupacion": 306,
        "descripcion": "Desactivador de explosivos"
      },
      {
        "idOcupacion": 600,
        "descripcion": "Ingeniero de ventilacion"
      },
      {
        "idOcupacion": 186,
        "descripcion": "Capataz - Trabajos de excavacion de tuneles"
      },
      {
        "idOcupacion": 382,
        "descripcion": "Empleado de calderas - refinerias"
      },
      {
        "idOcupacion": 311,
        "descripcion": "Deshollinador (hasta 15 metros)"
      },
      {
        "idOcupacion": 60,
        "descripcion": "Armero"
      },
      {
        "idOcupacion": 360,
        "descripcion": "Educador"
      },
      {
        "idOcupacion": 1096,
        "descripcion": "Obrero de Mineria - Tareas bajo tierra"
      },
      {
        "idOcupacion": 677,
        "descripcion": "Manipulacion de sustancias corrosivas o toxicas"
      },
      {
        "idOcupacion": 815,
        "descripcion": "Pintor"
      },
      {
        "idOcupacion": 212,
        "descripcion": "Chatarrero - Baterias"
      },
      {
        "idOcupacion": 1013,
        "descripcion": "Cientifico de investigacion de operaciones - Administrativo"
      },
      {
        "idOcupacion": 346,
        "descripcion": "Diseñador"
      },
      {
        "idOcupacion": 1055,
        "descripcion": "Ingeniero electronico - Administrativo"
      },
      {
        "idOcupacion": 717,
        "descripcion": "Militar"
      },
      {
        "idOcupacion": 907,
        "descripcion": "Sastre"
      },
      {
        "idOcupacion": 48,
        "descripcion": "Animador - Escenario, radio y TV"
      },
      {
        "idOcupacion": 633,
        "descripcion": "Instructor - Equitacion"
      },
      {
        "idOcupacion": 1059,
        "descripcion": "Ingeniero grafico - Administrativo"
      },
      {
        "idOcupacion": 567,
        "descripcion": "Ingeniero aerodeslizador"
      },
      {
        "idOcupacion": 74,
        "descripcion": "Asegurador"
      },
      {
        "idOcupacion": 505,
        "descripcion": "Geografo"
      },
      {
        "idOcupacion": 455,
        "descripcion": "Fisico"
      },
      {
        "idOcupacion": 295,
        "descripcion": "Cura"
      },
      {
        "idOcupacion": 70,
        "descripcion": "Artificiero de explosivos - Policia"
      },
      {
        "idOcupacion": 882,
        "descripcion": "Recepcionista"
      },
      {
        "idOcupacion": 129,
        "descripcion": "Barman"
      },
      {
        "idOcupacion": 713,
        "descripcion": "Mezclador de sonido - Industria musical - Entretenimiento"
      },
      {
        "idOcupacion": 99,
        "descripcion": "Autor"
      },
      {
        "idOcupacion": 1076,
        "descripcion": "Labores Administrativas en campamento"
      },
      {
        "idOcupacion": 641,
        "descripcion": "Instructor de actividades al aire libre"
      },
      {
        "idOcupacion": 735,
        "descripcion": "Montador - Gemas/piedras preciosas"
      }
    ]
  }
}